{
	"No access to these settings": "Nincs hozzáférésed ezekhez a beállításokhoz",
	"Your account is not allowed to view or change these settings.": "A fiókod nem tekintheti meg és nem módosíthatja ezeket a beállításokat.",
	"Showing cached data — you appear to be offline": "Gyorsítótárazott adatok — úgy tűnik, offline vagy",
	"That result cannot be opened": "Ez a találat nem nyitható meg",
	"Clear search history": "Keresési előzmények törlése",
	"apps": "alkalmazások",
	"people": "emberek",
	"links": "hivatkozások",
	"Remove from search history": "Eltávolítás a keresési előzményekből",
	"{{count}} results, use up and down arrows to review_one": "{{count}} találat, a fel és le nyíllal böngészhető",
	"{{count}} results, use up and down arrows to review_other": "{{count}} találat, a fel és le nyíllal böngészhető",
	"Quick search": "Gyorskeresés",
	"Search results": "Keresési találatok",
	"Search this space": "Keresés ebben a térben",
	"Type a few words to search files, documents, posts and people.": "Írj be néhány szót fájlok, dokumentumok, bejegyzések és emberek kereséséhez.",
	"Search is not available in this space": "A keresés nem érhető el ebben a térben",
	"No results found": "Nincs találat",
	"Try different words, or clear the filters.": "Próbálj más szavakat, vagy töröld a szűrőket.",
	"Loading more results...": "További találatok betöltése...",
	"Documents": "Dokumentumok",
	"Posts": "Bejegyzések",
	"Untitled": "Névtelen",
	"Linked post": "Hivatkozott bejegyzés",
	"Back to feed": "Vissza a hírfolyamhoz",
	"That post is no longer available": "Ez a bejegyzés már nem érhető el",
	"Reference copied": "Hivatkozás másolva",
	"Failed to copy reference": "A hivatkozás másolása nem sikerült",
	"Failed to post": "Nem sikerült közzétenni",
	"Failed to publish post": "Nem sikerült közzétenni a bejegyzést",
	"That doesn't look like a Cloudillo link": "Ez nem tűnik Cloudillo hivatkozásnak",
	"Copy reference": "Hivatkozás másolása",
	"Open reference": "Hivatkozás megnyitása",
	"Repost": "Megosztás",
	"Reposted by {{name}}": "{{name}} megosztotta",
	"Post quote": "Idézet közzététele",
	"Show more": "Tovább",
	"Show less": "Kevesebb",
	"Attachments aren't supported on reposts": "Megosztáshoz nem lehet csatolmányt adni",
	"Post to": "Közzététel ide",
	"Already reposted to {{name}}": "Már megosztva ide: {{name}}",
	"Tags": "Címkék",
	"Rename...": "Átnevezés...",
	"All": "Összes",
	"Login": "Bejelentkezés",
	"Password": "Jelszó",
	"You must provide a strong password!": "Adj meg egy erősebb jelszót!",
	"New password": "Új jelszó",
	"Change password": "Jelszó megváltoztatása",
	"Password changed successfully": "Jelszó sikeresen megváltoztatva",
	"Incorrect password!": "Érvénytelen jelszó!",
	"Current password": "Aktuális jelszó",
	"Confirm new password": "Új jelszó megerősítése",
	"Failed to change password": "Nem sikerült megváltoztatni a jelszót",
	"Set password": "Jelszó beállítása",
	"Feed": "Hírfolyam",
	"Files": "Fájlok",
	"Profile": "Profil",
	"Settings": "Beállítások",
	"General": "Általános",
	"Logout": "Kijelentkezés",
	"Add tag...": "Címke hozzáadása...",
	"OK": "OK",
	"Cancel": "Mégsem",
	"Yes": "Igen",
	"No": "Nem",
	"Email address": "Email cím",
	"Sign up": "Regisztráció",
	"Upload": "Feltöltés",
	"XD (4K)": "XD (4K)",
	"About": "Tartalom",
	"Follow": "Követem",
	"Following": "Követve",
	"Mutual": "Kölcsönös",
	"Follows you": "Követ téged",
	"Follow back": "Vissza követés",
	"See their posts in your feed": "Lásd a bejegyzéseiket a hírfolyamodban",
	"Connect to share privately": "Kapcsolódj a privát megosztáshoz",
	"Become a member and post here": "Legyél tag és posztolj ide",
	"Search": "Keresés",
	"Theme": "Téma",
	"Glass": "Üveg",
	"Opaque": "Átlátszatlan",
	"Use browser settings": "Böngésző beállítás használata",
	"Light": "Világos",
	"Dark": "Éjszakai",
	"Security": "Biztonság",
	"Notifications": "Értesítések",
	"Appearance": "Megjelenés",
	"Week starts on": "A hét kezdőnapja",
	"Automatic (locale default)": "Automatikus (területi beállítás alapján)",
	"Sunday": "Vasárnap",
	"Monday": "Hétfő",
	"Working hours": "Munkaidő",
	"Working days": "Munkanapok",
	"Start of working hours": "Munkaidő kezdete",
	"End of working hours": "Munkaidő vége",
	"Enable push notifications on this device": "Push értesítések engedélyezése ezen a készüléken",
	"Enable push notifications": "Push értesítések engedélyezése",
	"Notify on connection requests": "Értesítés kapcsolat kérelmek esetén",
	"Notify on direct messages": "Értesítés közvetlen üzenetek esetén",
	"Notify when files are shared with you": "Értesítés veled megosztott fájlokról",
	"Notify when someone follows you": "Értesítés ha valaki követ",
	"Notify on comments to your posts": "Értesítés a bejegyzéseidre érkező kommentekről",
	"Notify on reactions to your posts": "Értesítés a bejegyzéseidre érkező reakciókról",
	"Notify on new posts from people you follow": "Értesítés a követett emberek új bejegyzéseiről",
	"Enable email notifications": "Email értesítések engedélyezése",
	"Direct": "Közvetlen",
	"Engagement": "Interakciók",
	"Social": "Közösségi",
	"While you’re away, we email you about the first item in each group, then pause for a day so your inbox stays calm.": "Amíg távol vagy, e-mailt küldünk az egyes csoportok első eseményéről, majd egy napra szünetet tartunk, hogy a postaládád nyugodt maradjon.",
	"Create document": "Dokumentum létrehozása",
	"Provide a name for the new document": "Add meg a dokumentum nevét",
	"Untitled document": "Névtelen dokumentum",
	"Quillo text document": "Quillo szöveges dokumentum",
	"Calcillo spreadsheet document": "Calcillo táblázat",
	"Ideallo whiteboard document": "Ideallo tábla",
	"Prezillo presentation document": "Prezillo prezentáció",
	"Pagillo publication": "Pagillo kiadvány",
	"Remember me on this device": "Emlékezz rám ezen a készüléken",
	"What is Identity?": "Mi az az Azonosító?",
	"REGISTER-FORM-IDENTITY-INFO": "Az azonosítás alapvető minden platformon, ahol a felhasználók kapcsolatokat építenek ki egymással.\n\nA legtöbb plarformon az erre használt azonosító a platform tulajdonosának irányítása alatt van, így nincs más választásod, mint az ő rendszerükre hagyatkozni. A Cloudillo más – nyílt és nincs központi tulajdonosa, így szabadon választhatsz azonosító szolgáltatót.\n\na Cloudillo azonosítórendszere az internet tartománynév szolgáltatását (Domain Name System, DNS) használja – ugyanazt a rendszert, amelyre az egész internet támaszkodik a weboldalak, emailek és egyéb szolgáltatások esetében. Bár ez bizonyos mértékű szolgáltatói függőséget jelent, a DNS globálisan megbízható és decentralizált, így kiegyensúlyozott és praktikus megoldás.\n\nHa rendelkezel egy **domain névvel**, azt használhatod Cloudillo Azonosítóként (az azonosítók elé **\"@\"** jelet írunk, pl. **@yourdomain.com**). Korlátlan számú al-azonosítót hozhatsz létre aldomainek segítségével (pl. **@alice.yourdomain.com**, **@bob.yourdomain.com**).\n\nAlternatívaként használhatod a **Cloudillo Azonosító Szolgáltatást (Cloudillo Identity Provider)**, ami a Cloudillót fejlesztő vállalat által nyújtott szolgáltatás. Ennek segítségével **@sajátneved.cloudillo.net** formájú azonosítót használhatsz. Bár ez azt jelenti, hogy rábízod az azonosítód kezelését egy cégre, továbbra is te irányítod, hogy hol tárolódjanak az adataid — ellentétben a legtöbb más platformmal.\n\nGondolj az azonosítódra úgy, mint egy címre — segít másoknak megtalálni és kapcsolatba lépni veled. Ez teszi lehetővé a Cloudillo felhasználói számára, hogy szabadon mozgathassák adataikat egyik tárhelyszolgáltatótól a másikhoz, így jelentősen csökkentsék a szolgáltatói függésüket.",
	"This registration link is invalid!": "Ez a regisztráció link nem érvényes!",
	"Too many requests": "Túl sok kérés",
	"Please wait a moment and try again.": "Kérlek, várj egy pillanatot, majd próbáld újra.",
	"Welcome to Cloudillo!": "Üdvözöl a Cloudillo!",
	"Password must be at least 8 characters long": "A jelszónak legalább 8 karakter hosszúnak kell lennie",
	"Go back": "Vissza",
	"Registration is in progress": "A regisztráció folyamatban van",
	"This usually takes only 10-20 seconds, please be patient...": "Ez általában 10-20 másodpercet vesz igénybe, kérlek várj türelemmel...",
	"Registration is successful": "Sikeres regisztráció",
	"Checking app domain...": "App domain ellenőrzése...",
	"Registration Successful!": "Sikeres regisztráció!",
	"What happens next?": "Mi történik ezután?",
	"Check your inbox to continue.": "Nézd meg a beérkezett leveleid a folytatáshoz.",
	"It may take up to an hour before your account is fully ready.": "Akár egy órába is telhet, mire a fiókod teljesen készen áll.",
	"You're all set here!": "Minden készen áll!",
	"Something went wrong!": "Valami nem sikerült!",
	"Your registration was unsuccessful.": "A regisztrációd sikertelen volt.",
	"More": "Továbbiak",
	"Wants to connect": "Kapcsolódni szeretne",
	"is now a connection": "új kapcsolatod",
	"User disconnected, or refused to connect": "Felhasználó elutasította a kapcsolatot",
	"Wants to share a file with you": "Egy fájlt szeretne megosztani Veled",
	"Enable notifications": "Értesítések bekapcsolása",
	"Connected": "Kapcsolódva",
	"Are you sure?": "Biztos vagy benne?",
	"Unfollow this person?": "Biztosan kikapcsolod a profil követését?",
	"Unblock": "Blokkolás törlése",
	"Connect": "Kapcsolódás",
	"Unfollow": "Követés törlése",
	"Cancel request": "Kérés visszavonása",
	"Disconnect": "Kapcsolat bontása",
	"Block": "Blokkolás",
	"Members": "Tagok",
	"Search members": "Tagok keresése",
	"Role": "Szerep",
	"Member actions": "Tag műveletek",
	"Connections": "Kapcsolatok",
	"Connection request": "Kapcsolatfelvételi kérelem",
	"Are you sure you want to send a connection request?": "Biztos vagy benne, hogy elküldöd a kapcsolatfelvételi kérelmet?",
	"Personalize the connection request": "Kapcsolatfelvétel testreszabása",
	"Cancel connection": "Kapcsolat visszavonása",
	"Are you sure you want to disconnect?": "Biztosan bontani akarod a kapcsolatot?",
	"Invitations": "Meghívók",
	"Create invitation": "Meghívó létrehozása",
	"Delete invitation": "Meghívó törlése",
	"Are you sure you want to delete this invitation?": "Biztos vagy benne, hogy törölni akarod a meghívót?",
	"Message": "Üzenet",
	"yesterday": "tegnap",
	"tomorrow": "holnap",
	"sunday": "vasárnap",
	"monday": "hétfő",
	"tuesday": "kedd",
	"wednesday": "szerda",
	"thursday": "csütörtök",
	"friday": "péntek",
	"saturday": "szombat",
	"1 hour": "1 óra",
	"{{count}} minutes_one": "{{count}} perc",
	"{{count}} minutes_other": "{{count}} perc",
	"1 min": "1 perc",
	"just now": "most",
	"Enter domain (e.g., cloudillo.net)": "Add meg a domain-t (pl. cloudillo.net)",
	"Add": "Hozzáadás",
	"Remove": "Eltávolítás",
	"Please enter a domain": "Kérlek adj meg egy domain-t",
	"Invalid domain format": "Érvénytelen domain formátum",
	"Domain already exists": "A domain már létezik",
	"Back": "Vissza",
	"Try again": "Próbáld újra",
	"Please contact the administrator of the server or try again.": "Kérlek vedd fel a kapcsolatot a szerver adminisztrátorával vagy próbáld újra.",
	"Search user": "Felhasználó keresése",
	"{{count}} hours_one": "{{count}} óra",
	"{{count}} hours_other": "{{count}} óra",
	"No posts yet": "Még nincsenek bejegyzések",
	"Be the first to share something with your community!": "Légy te az első, aki megoszt valamit a közösséggel!",
	"Create database": "Adatbázis létrehozása",
	"Provide a name for the new database": "Add meg az adatbázis nevét",
	"Untitled database": "Névtelen adatbázis",
	"Taskillo task list": "Taskillo feladatlista",
	"Loading files...": "Fájlok betöltése...",
	"No files found": "Nincsenek fájlok",
	"Create a new document or upload files to get started": "Hozz létre egy dokumentumot vagy tölts fel fájlokat a kezdéshez",
	"Loading gallery...": "Galéria betöltése...",
	"No images found": "Nincsenek képek",
	"Upload some images to see them here": "Tölts fel képeket, hogy itt lásd őket",
	"Select a conversation": "Válassz egy beszélgetést",
	"Choose a contact from the list to start messaging": "Válassz egy kapcsolatot a listából az üzenetküldéshez",
	"No messages yet": "Még nincsenek üzenetek",
	"Start the conversation by sending a message!": "Kezdd el a beszélgetést egy üzenet küldésével!",
	"How would you like to be known?": "Hogyan szeretnél megjelenni?",
	"Use my own domain as my identity": "Saját domain használata azonosítóként",
	"You'll be": "Így jelensz meg:",
	"Full control, requires DNS setup": "Teljes kontroll, DNS beállítás szükséges",
	"Use an Identity Provider": "Azonosító Szolgáltató használata",
	"Quick setup - choose from available providers": "Gyors beállítás - válassz az elérhető szolgáltatók közül",
	"This choice is hard to change later - pick what fits you best.": "Ezt a választást később nehéz megváltoztatni - válaszd azt, ami a legjobban illik hozzád.",
	"Learn more": "További információk",
	"Choose an Identity Provider": "Válassz Azonosító Szolgáltatót",
	"Your identity will be": "Az azonosítód ez lesz:",
	"Default": "Alapértelmezett",
	"Provider information not available": "A szolgáltató információi nem elérhetők",
	"Other provider...": "Más szolgáltató...",
	"Enter a provider domain you know": "Add meg egy ismert szolgáltató domain-jét",
	"example.provider.net": "pelda.szolgaltato.hu",
	"This provider is not available or does not support Cloudillo identity.": "Ez a szolgáltató nem elérhető vagy nem támogatja a Cloudillo azonosítást.",
	"Continue with selected provider": "Folytatás a kiválasztott szolgáltatóval",
	"Choose your name on {{provider}}": "Válaszd ki a neved a {{provider}} szolgáltatónál",
	"You'll be known as": "Így fognak ismerni:",
	"Your name": "A neved",
	"yourname": "aneved",
	"This name contains invalid characters. Use only letters, numbers, and hyphens.": "Ez a név érvénytelen karaktereket tartalmaz. Csak betűket, számokat és kötőjeleket használhatsz.",
	"This name is already taken. Please try another one.": "Ez a név már foglalt. Kérlek próbálj egy másikat.",
	"Pick something memorable that represents you.": "Válassz valami emlékezeteset, ami téged képvisel.",
	"Your email (for account recovery)": "Email címed (fiók helyreállításhoz)",
	"you@example.com": "te@pelda.hu",
	"Use your domain as your identity": "Használd a domain-ed azonosítóként",
	"Your domain": "A domain-ed",
	"example.com or alice.example.com": "pelda.hu vagy anna.pelda.hu",
	"Please enter a valid domain name (e.g., example.com)": "Kérlek adj meg egy érvényes domain nevet (pl. pelda.hu)",
	"This domain is already registered with this Cloudillo instance.": "Ez a domain már regisztrálva van ennél a Cloudillo példánynál.",
	"Where will you access Cloudillo?": "Hol fogod elérni a Cloudillót?",
	"Your identity:": "Azonosítód:",
	"App address:": "App cím:",
	"App address": "App cím",
	"Please enter a valid domain name.": "Kérlek adj meg egy érvényes domain nevet.",
	"This app address is already in use.": "Ez az app cím már használatban van.",
	"One small step: connect your domain": "Egy kis lépés: kösd össze a domain-ed",
	"Add these records in your domain settings:": "Add hozzá ezeket a rekordokat a domain beállításaidhoz:",
	"Me": "Én",
	"Recent": "Legutóbbi",
	"You're in!": "Bent vagy!",
	"Connect with other Cloudillo users, get help, and stay updated on new features.": "Kapcsolódj más Cloudillo felhasználókkal, kérj segítséget és értesülj az új funkciókról.",
	"A couple more things": "Még néhány dolog",
	"optional": "opcionális",
	"Know when someone messages you": "Tudj róla, ha valaki üzenetet küld neked",
	"Add to home screen": "Hozzáadás a kezdőképernyőhöz",
	"Quick access on your phone": "Gyors elérés a telefonodon",
	"Invalid or missing reference ID": "Érvénytelen vagy hiányzó hivatkozási azonosító",
	"Invalid or expired reference link": "Érvénytelen vagy lejárt hivatkozási link",
	"Passwords do not match": "A jelszavak nem egyeznek",
	"Too short": "Túl rövid",
	"Weak": "Gyenge",
	"Fair": "Közepes",
	"Good": "Jó",
	"Strong": "Erős",
	"Failed to set password": "Nem sikerült beállítani a jelszót",
	"Validating invitation link...": "Meghívó link ellenőrzése...",
	"Set Your Password": "Állítsd be a jelszavad",
	"Please choose a strong password to secure your account.": "Kérlek válassz egy erős jelszót a fiókod védelméhez.",
	"Enter a strong password": "Adj meg egy erős jelszót",
	"Confirm Password": "Jelszó megerősítése",
	"Confirm your password": "Erősítsd meg a jelszavad",
	"Password set successfully. Redirecting...": "Jelszó sikeresen beállítva. Átirányítás...",
	"Set Password": "Jelszó beállítása",
	"Email Configuration": "Email konfiguráció",
	"Enable email sending": "Email küldés engedélyezése",
	"Disable for testing. When disabled, email features will be silently skipped.": "Teszteléshez kikapcsolható. Kikapcsolt állapotban az email funkciók csendben kihagyásra kerülnek.",
	"SMTP Server Configuration": "SMTP szerver konfiguráció",
	"SMTP Host": "SMTP hoszt",
	"SMTP server hostname. Example: smtp.gmail.com": "SMTP szerver hosztneve. Példa: smtp.gmail.com",
	"SMTP Port": "SMTP port",
	"Typically 25 (SMTP), 465 (SMTPS), or 587 (Submission with STARTTLS)": "Általában 25 (SMTP), 465 (SMTPS), vagy 587 (Submission STARTTLS-sel)",
	"TLS Mode": "TLS mód",
	"None": "Nincs",
	"STARTTLS (recommended)": "STARTTLS (ajánlott)",
	"TLS/SSL": "TLS/SSL",
	"STARTTLS on port 587, TLS/SSL on port 465": "STARTTLS a 587-es porton, TLS/SSL a 465-ös porton",
	"Connection Timeout (seconds)": "Kapcsolat időtúllépés (másodperc)",
	"How long to wait before abandoning connection": "Mennyi ideig várjon a kapcsolat feladása előtt",
	"SMTP Authentication": "SMTP hitelesítés",
	"Username": "Felhasználónév",
	"SMTP authentication username (optional)": "SMTP hitelesítési felhasználónév (opcionális)",
	"SMTP authentication password (optional)": "SMTP hitelesítési jelszó (opcionális)",
	"Sender Configuration": "Küldő konfiguráció",
	"From Address": "Feladó cím",
	"Email address that will appear as the sender": "Az email cím, ami feladóként jelenik meg",
	"From Name": "Feladó név",
	"Display name for the sender": "A feladó megjelenítési neve",
	"Advanced Options": "Haladó beállítások",
	"Retry Attempts": "Újrapróbálkozások száma",
	"Number of times to retry sending failed emails": "Hányszor próbálja újra a sikertelen email küldést",
	"Identity Provider Configuration": "Azonosító Szolgáltató konfiguráció",
	"Enable Identity Provider functionality": "Azonosító Szolgáltató funkció engedélyezése",
	"Allow this tenant to act as an identity provider for other users": "Engedélyezd, hogy ez a bérlő azonosító szolgáltatóként működjön más felhasználók számára",
	"Renewal interval (days)": "Megújítási időköz (nap)",
	"How long identity credentials are valid": "Mennyi ideig érvényesek az azonosító hitelesítő adatok",
	"years": "év",
	"Provider Public Info": "Szolgáltató nyilvános információi",
	"This information is shown to users during registration when they choose an identity provider.": "Ez az információ jelenik meg a felhasználóknak regisztrációkor, amikor azonosító szolgáltatót választanak.",
	"Provider Name": "Szolgáltató neve",
	"e.g., Cloudillo": "pl. Cloudillo",
	"Display name shown to users (defaults to domain if empty)": "A felhasználóknak megjelenített név (üres esetén a domain)",
	"Provider Info": "Szolgáltató információ",
	"e.g., Free during early access. ~€3/year after launch.": "pl. Ingyenes a korai hozzáférés idején. ~€3/év az indulás után.",
	"Short description with pricing, terms, or other important info": "Rövid leírás árazással, feltételekkel vagy egyéb fontos információkkal",
	"More Info URL": "További információ URL",
	"e.g., https://cloudillo.net/about": "pl. https://cloudillo.net/about",
	"Optional link for more details about the provider": "Opcionális link a szolgáltatóról szóló további részletekhez",
	"Server": "Szerver",
	"Storage": "Tárhely",
	"Email": "Email",
	"Tenant Settings": "Bérlő beállítások",
	"Allow new user registrations": "Új felhasználók regisztrációjának engedélyezése",
	"Controls whether new users can register on this instance": "Szabályozza, hogy regisztrálhatnak-e új felhasználók ezen a példányon",
	"Global Settings": "Globális beállítások",
	"Maximum file upload size (MB)": "Maximális fájl feltöltési méret (MB)",
	"Maximum size for individual file uploads": "Egyedi fájl feltöltések maximális mérete",
	"Maximum size variant to generate": "Generálandó maximális méretváltozat",
	"Largest image size variant to automatically generate and store": "A legnagyobb automatikusan generálandó és tárolandó képméret változat",
	"Maximum size variant to cache": "Gyorsítótárazandó maximális méretváltozat",
	"Largest image size variant to download and cache from remote instances": "A legnagyobb letöltendő és gyorsítótárazandó képméret változat távoli példányokról",
	"Thumbnail format": "Bélyegkép formátum",
	"Image format for thumbnail (tn) variant": "Képformátum a bélyegkép (tn) változathoz",
	"Note: AVIF provides best compression but can be slow to encode": "Megjegyzés: Az AVIF biztosítja a legjobb tömörítést, de lassú lehet a kódolás",
	"Image format for larger variants": "Képformátum a nagyobb változatokhoz",
	"Image format for sd, md, hd, and xd variants": "Képformátum az sd, md, hd és xd változatokhoz",
	"Authentication": "Hitelesítés",
	"Session Timeout": "Munkamenet időtúllépés",
	"Session timeout in seconds": "Munkamenet időtúllépés másodpercben",
	"hours": "óra",
	"Auto-accept follow requests": "Követési kérelmek automatikus elfogadása",
	"Automatically accept follow requests from other instances": "Követési kérelmek automatikus elfogadása más példányokról",
	"History sync window (days)": "Előzmény szinkronizálási időablak (nap)",
	"Default age window in days for history sync on new connection.": "Alapértelmezett életkor-ablak napokban az új kapcsolat előzményeinek szinkronizálásához.",
	"History sync limit": "Előzmény szinkronizálási korlát",
	"Default maximum number of actions to fetch per history sync.": "Alapértelmezett maximum lekért műveletek száma előzmény szinkronizálásonként.",
	"Key failure cache size": "Kulcs-hiba gyorsítótár mérete",
	"Maximum entries in the key fetch failure cache (in-memory LRU). Note: takes effect on next process restart.": "Maximum bejegyzések száma a kulcs-lekérési hiba gyorsítótárban (memóriában tárolt LRU). Megjegyzés: a következő folyamat-újraindításkor lép érvénybe.",
	"Maximum Storage Quota (GB)": "Maximális tárhely kvóta (GB)",
	"File Synchronization": "Fájl szinkronizálás",
	"Control which file variants are synchronized to your device": "Állítsd be, mely fájl változatokat szinkronizálja az eszközödre",
	"Max image quality": "Max kép minőség",
	"Max video quality": "Max videó minőség",
	"Max audio quality": "Max hangfájl minőség",
	"Files & Storage": "Fájlok és tárhely",
	"Search index": "Keresési index",
	"Store indexed document text": "Indexelt dokumentumszöveg tárolása",
	"Failed to load the search index setting.": "A keresési index beállítás betöltése sikertelen.",
	"Keeps a plain-text copy of your documents and posts alongside the search index so results can show highlighted snippets. Turning this off makes the index substantially smaller; search still works, but snippets are no longer available.": "Egyszerű szöveges másolatot tart a dokumentumaidról és bejegyzéseidről a keresési index mellett, így a találatok kiemelt részleteket mutathatnak. Kikapcsolva az index lényegesen kisebb lesz; a keresés továbbra is működik, de részletek már nem jelennek meg.",
	"Rebuild search index?": "Újraépíted a keresési indexet?",
	"Search results will be incomplete until the index is rebuilt. This runs in the background and may take several minutes. Rebuild now?": "A keresési találatok hiányosak lesznek, amíg az index újra nem épül. A művelet a háttérben fut, és több percig is eltarthat. Újraépíted most?",
	"Breadcrumb": "Útvonal",
	"Restore": "Visszaállítás",
	"Restore {{count}} items_one": "{{count}} elem visszaállítása",
	"Restore {{count}} items_other": "{{count}} elem visszaállítása",
	"Delete permanently": "Végleges törlés",
	"Delete {{count}} items permanently_one": "{{count}} elem végleges törlése",
	"Delete {{count}} items permanently_other": "{{count}} elem végleges törlése",
	"Open folder": "Mappa megnyitása",
	"Open": "Megnyitás",
	"View": "Megtekintés",
	"Download": "Letöltés",
	"Share...": "Megosztás...",
	"Rename": "Átnevezés",
	"Move to trash": "Áthelyezés a kukába",
	"Move {{count}} items to trash_one": "{{count}} elem áthelyezése a kukába",
	"Move {{count}} items to trash_other": "{{count}} elem áthelyezése a kukába",
	"{{count}} items selected_one": "{{count}} elem kiválasztva",
	"{{count}} items selected_other": "{{count}} elem kiválasztva",
	"Share link deleted": "Megosztási link törölve",
	"Failed to delete share link": "Nem sikerült törölni a megosztási linket",
	"Link copied to clipboard": "Link másolva a vágólapra",
	"Sharing": "Megosztás",
	"Can edit": "Szerkeszthet",
	"Can comment": "Hozzászólhat",
	"Read only": "Csak olvasható",
	"Expires": "Lejárat",
	"Never expires": "Soha nem jár le",
	"Copy link": "Link másolása",
	"Delete link": "Link törlése",
	"Drop files here to upload": "Húzd ide a fájlokat a feltöltéshez",
	"Move here": "Áthelyezés ide",
	"Show details": "Részletek megjelenítése",
	"Edit (hold for view mode)": "Szerkesztés (tartsd nyomva a megtekintéshez)",
	"No access": "Nincs hozzáférés",
	"Permission granted": "Jogosultság megadva",
	"Failed to grant permission": "Nem sikerült megadni a jogosultságot",
	"Permission revoked": "Jogosultság visszavonva",
	"Failed to revoke permission": "Nem sikerült visszavonni a jogosultságot",
	"Share link created": "Megosztási link létrehozva",
	"Failed to create share link": "Nem sikerült létrehozni a megosztási linket",
	"Share": "Megosztás",
	"Close": "Bezárás",
	"People": "Emberek",
	"Access": "Hozzáférés",
	"Label": "Címke",
	"e.g. For review, Public access...": "pl. Áttekintéshez, Nyilvános hozzáférés...",
	"Never": "Soha",
	"Creating...": "Létrehozás...",
	"Create Link": "Link létrehozása",
	"Delete this link?": "Törli ezt a linket?",
	"Delete": "Törlés",
	"All files": "Összes fájl",
	"Live": "Élő",
	"Static": "Statikus",
	"Trash": "Kuka",
	"Managed": "Kezelt",
	"Clear": "Törlés",
	"Upload files": "Fájlok feltöltése",
	"New folder": "Új mappa",
	"New": "Új",
	"Create or upload": "Létrehozás vagy feltöltés",
	"Empty trash": "Kuka ürítése",
	"List view": "Lista nézet",
	"Grid view": "Rács nézet",
	"Uploading {{completed}} of {{total}}": "Feltöltés: {{completed}}/{{total}}",
	"{{completed}} uploaded, {{errors}} failed": "{{completed}} feltöltve, {{errors}} sikertelen",
	"{{completed}} files uploaded": "{{completed}} fájl feltöltve",
	"Clear completed": "Befejezettek törlése",
	"Clear all": "Összes törlése",
	"Already on server — reused existing file": "Már a szerveren — meglévő fájl újrahasznosítva",
	"reused": "újrahasznosítva",
	"Create folder": "Mappa létrehozása",
	"Provide a name for the new folder": "Add meg az új mappa nevét",
	"Untitled folder": "Névtelen mappa",
	"Are you sure you want to permanently delete all files in trash? This action cannot be undone.": "Biztosan véglegesen törölni akarod a kuka összes fájlját? Ez a művelet nem vonható vissza.",
	"Move folder to trash": "Mappa áthelyezése a kukába",
	"Are you sure you want to move this folder and its contents to trash?": "Biztosan át akarod helyezni ezt a mappát és tartalmát a kukába?",
	"Are you sure you want to move this file to trash?": "Biztosan át akarod helyezni ezt a fájlt a kukába?",
	"Permanently delete": "Végleges törlés",
	"Are you sure you want to permanently delete this file? This action cannot be undone.": "Biztosan véglegesen törölni akarod ezt a fájlt? Ez a művelet nem vonható vissza.",
	"Are you sure you want to move {{count}} items to trash?_one": "Biztosan át akarod helyezni {{count}} elemet a kukába?",
	"Are you sure you want to move {{count}} items to trash?_other": "Biztosan át akarod helyezni {{count}} elemet a kukába?",
	"Are you sure you want to permanently delete {{count}} items? This action cannot be undone._one": "Biztosan véglegesen törölni akarsz {{count}} elemet? Ez a művelet nem vonható vissza.",
	"Are you sure you want to permanently delete {{count}} items? This action cannot be undone._other": "Biztosan véglegesen törölni akarsz {{count}} elemet? Ez a művelet nem vonható vissza.",
	"Trash is empty": "A kuka üres",
	"No recent files": "Nincsenek legutóbbi fájlok",
	"This folder is empty": "Ez a mappa üres",
	"Files you delete will appear here": "A törölt fájlok itt jelennek meg",
	"Files you open will appear here": "A megnyitott fájlok itt jelennek meg",
	"Unnamed Group": "Névtelen csoport",
	"{{count}} members_one": "{{count}} tag",
	"{{count}} members_other": "{{count}} tag",
	"Group": "Csoport",
	"Visibility": "Láthatóság",
	"Verified": "Ellenőrzött",
	"Groups": "Csoportok",
	"Create Group": "Csoport létrehozása",
	"Search conversations...": "Beszélgetések keresése...",
	"Pending Invitations": "Függőben lévő meghívók",
	"Group invitation": "Csoport meghívó",
	"From": "Feladó",
	"Accept": "Elfogadás",
	"Reject": "Elutasítás",
	"No groups yet": "Még nincsenek csoportok",
	"No direct messages": "Nincsenek közvetlen üzenetek",
	"No conversations": "Nincsenek beszélgetések",
	"Create a group to chat with multiple people": "Hozz létre egy csoportot több emberrel való csevegéshez",
	"Connect with someone to start messaging": "Kapcsolódj valakivel az üzenetküldés megkezdéséhez",
	"Start a conversation or create a group": "Kezdj beszélgetést vagy hozz létre egy csoportot",
	"Observer": "Megfigyelő",
	"Member": "Tag",
	"Leave": "Kilépés",
	"Moderator": "Moderátor",
	"Admin": "Adminisztrátor",
	"Leave Group": "Csoport elhagyása",
	"Are you sure you want to leave \"{{name}}\"?": "Biztosan el akarod hagyni a(z) \"{{name}}\" csoportot?",
	"invited": "meghívott",
	"Invite member": "Tag meghívása",
	"No members": "Nincsenek tagok",
	"Invited": "Meghívott",
	"You": "Te",
	"Group details": "Csoport részletek",
	"Group Name": "Csoport neve",
	"Enter group name...": "Add meg a csoport nevét...",
	"Description": "Leírás",
	"Optional description...": "Opcionális leírás...",
	"Open group": "Nyitott csoport",
	"Closed group": "Zárt csoport",
	"Anyone can join without invitation": "Bárki csatlakozhat meghívó nélkül",
	"Members must be invited": "A tagokat meg kell hívni",
	"Add Members": "Tagok hozzáadása",
	"Invite Members": "Tagok meghívása",
	"Select members to invite": "Válaszd ki a meghívandó tagokat",
	"Send Invites": "Meghívók küldése",
	"File not found": "Fájl nem található",
	"Failed to load shared resource": "Nem sikerült betölteni a megosztott erőforrást",
	"This link has expired or does not exist": "Ez a link lejárt vagy nem létezik",
	"This link has reached its usage limit": "Ez a link elérte a használati korlátját",
	"Link Error": "Link hiba",
	"Unsupported file type": "Nem támogatott fájltípus",
	"Your browser does not support video playback": "A böngésződ nem támogatja a videó lejátszást",
	"Failed to load file": "Nem sikerült betölteni a fájlt",
	"Loading...": "Betöltés...",
	"Error": "Hiba",
	"Fullscreen": "Teljes képernyő",
	"Please enter a valid email address": "Kérlek adj meg egy érvényes email címet",
	"Reset Password": "Jelszó visszaállítása",
	"Forgot password?": "Elfelejtetted a jelszavad?",
	"Your registered email: {{email}}": "A regisztrált email címed: {{email}}",
	"Enter your email address and we'll send you a link to reset your password.": "Add meg az email címedet és küldünk egy linket a jelszó visszaállításához.",
	"If an account with this email exists, you'll receive a password reset link shortly.": "Ha létezik fiók ezzel az email címmel, hamarosan kapsz egy jelszó visszaállító linket.",
	"Send reset link": "Visszaállító link küldése",
	"Login with passkey": "Bejelentkezés jelkulccsal",
	"No passkey is registered for this account.": "Ehhez a fiókhoz nincs regisztrált jelkulcs.",
	"Passkey login failed": "A jelkulccsal való bejelentkezés sikertelen",
	"Invalid or missing activation reference": "Érvénytelen vagy hiányzó aktiválási hivatkozás",
	"This activation link has expired or is no longer valid.": "Ez az aktiválási link lejárt vagy már nem érvényes.",
	"This identity has already been activated.": "Ez az azonosító már aktiválva lett.",
	"Failed to activate identity": "Nem sikerült aktiválni az azonosítót",
	"Identity Activation": "Azonosító aktiválása",
	"Activating your identity...": "Azonosító aktiválása...",
	"Activation failed": "Az aktiválás sikertelen",
	"Your identity has been activated successfully!": "Az azonosítód sikeresen aktiválva lett!",
	"What's next?": "Mi következik?",
	"If you registered a personal identity, check your inbox for a welcome email to finish setting up your profile.": "Ha személyes azonosítót regisztráltál, ellenőrizd a beérkezett leveleidet az üdvözlő emailért, amellyel befejezheted a profilod beállítását.",
	"If you activated a community identity, it is now ready to use in Cloudillo.": "Ha közösségi azonosítót aktiváltál, az most már használható a Cloudillóban.",
	"Invalid or expired password reset link": "Érvénytelen vagy lejárt jelszó visszaállító link",
	"Failed to reset password": "Nem sikerült visszaállítani a jelszót",
	"Validating reset link...": "Visszaállító link ellenőrzése...",
	"Set Your New Password": "Állítsd be az új jelszavad",
	"New Password": "Új jelszó",
	"Password reset successfully. Redirecting to login...": "Jelszó sikeresen visszaállítva. Átirányítás a bejelentkezéshez...",
	"DNS propagation in progress...": "DNS propagáció folyamatban...",
	"Setting up...": "Beállítás...",
	"Create new community": "Új közösség létrehozása",
	"Hosted by": "Tulajdonos",
	"Shared by": "Megosztotta",
	"Create a Community": "Közösség létrehozása",
	"Name your community on {{provider}}": "Nevezd el a közösséged a {{provider}} szolgáltatónál",
	"Your community will be": "A közösséged ez lesz:",
	"Community identifier": "Közösség azonosító",
	"communityname": "kozossegnev",
	"Display name": "Megjelenítési név",
	"My Community": "Az én közösségem",
	"You can change the display name later.": "A megjelenítési nevet később megváltoztathatod.",
	"Create Community": "Közösség létrehozása",
	"Use your domain for your community": "Használd a domain-ed a közösségedhez",
	"Community domain": "Közösség domain",
	"myteam.com": "csapatom.hu",
	"Community identity:": "Közösség azonosító:",
	"Where will the community be accessed?": "Hol lesz elérhető a közösség?",
	"My Team": "A csapatom",
	"Creating your community...": "Közösséged létrehozása...",
	"This usually takes only a few seconds, please be patient...": "Ez általában csak néhány másodpercet vesz igénybe, kérlek légy türelmes...",
	"Community created!": "Közösség létrehozva!",
	"Checking if your community is accessible...": "Ellenőrzés, hogy elérhető-e a közösséged...",
	"Your community is ready!": "A közösséged készen áll!",
	"Open Community": "Közösség megnyitása",
	"Your community has been created, but DNS propagation is still in progress.": "A közösséged létrejött, de a DNS propagáció még folyamatban van.",
	"It's been added to your sidebar. You can try opening it in a few minutes.": "Hozzáadtuk az oldalsávodhoz. Néhány perc múlva megpróbálhatod megnyitni.",
	"Something went wrong": "Valami hiba történt",
	"Please try again or contact support.": "Kérlek próbáld újra vagy lépj kapcsolatba a támogatással.",
	"Try Again": "Próbáld újra",
	"Activation email": "Aktiváló email",
	"from your Identity Provider": "az Azonosító Szolgáltatódtól",
	"Click to activate your federated identity": "Kattints a szövetségi azonosítód aktiválásához",
	"Onboarding email": "Üdvözlő email",
	"from this Cloudillo instance": "ettől a Cloudillo példánytól",
	"Click to set up your account and password": "Kattints a fiókod és jelszavad beállításához",
	"We have sent an onboarding link to your email address. Please check your inbox to continue setting up your account.": "Küldtünk egy üdvözlő linket az email címedre. Kérlek ellenőrizd a beérkezett leveleidet a fiókod beállításának folytatásához.",
	"If you set up custom DNS records, it may take some time for changes to propagate.": "Ha egyéni DNS rekordokat állítottál be, a változások életbe lépése időbe telhet.",
	"How would you like your community to be identified?": "Hogyan szeretnéd, hogy a közösséged azonosítva legyen?",
	"Use your own domain": "Saját domain használata",
	"Continue": "Folytatás",
	"Could not verify availability. Please check your internet connection and try again.": "Nem sikerült ellenőrizni az elérhetőséget. Kérlek ellenőrizd az internet kapcsolatod és próbáld újra.",
	"Usually the same as your identity domain. Use a subdomain only if your main domain already has a website.": "Általában megegyezik az azonosító domain-eddel. Csak akkor használj aldomaint, ha a fő domain-eden már van weboldal.",
	"Where to do this: GoDaddy, Namecheap, Cloudflare - 'DNS Settings'": "Hol találod: GoDaddy, Namecheap, Cloudflare - 'DNS beállítások'",
	"Colors": "Színek",
	"Privacy": "Adatvédelem",
	"Disabled": "Kikapcsolva",
	"Sound notifications": "Hangos értesítések",
	"These settings are stored locally on this device": "Ezek a beállítások ezen az eszközön helyileg tárolódnak",
	"Browsers may block sounds until you interact with the page. Click the test button to enable sounds.": "A böngészők blokkolhatják a hangokat, amíg nem lépsz interakcióba az oldallal. Kattints a teszt gombra a hangok engedélyezéséhez.",
	"Test sound": "Hang tesztelése",
	"Volume when tab is active": "Hangerő aktív fül esetén",
	"Volume when tab is inactive (background)": "Hangerő inaktív fül esetén (háttérben)",
	"Direct messages": "Közvetlen üzenetek",
	"Connection requests": "Kapcsolatfelvételi kérelmek",
	"File sharing": "Fájl megosztás",
	"New followers": "Új követők",
	"Comments": "Hozzászólások",
	"Comments on your posts": "Hozzászólások a bejegyzéseidhez",
	"Reactions to your posts": "Reakciók a bejegyzéseidre",
	"Mentions": "Említések",
	"Posts from followed users": "Követett felhasználók bejegyzései",
	"Enable toast notifications": "Felugró értesítések engedélyezése",
	"Get more out of Cloudillo": "Hozd ki a legtöbbet a Cloudillóból",
	"Install App": "Alkalmazás telepítése",
	"Get faster access with the app on your device": "Gyorsabb hozzáférés az alkalmazással az eszközödön",
	"Install": "Telepítés",
	"Enable Notifications": "Értesítések engedélyezése",
	"Stay updated when someone messages you": "Maradj naprakész, ha valaki üzenetet küld neked",
	"Enable": "Engedélyezés",
	"Add a Passkey": "Jelkulcs hozzáadása",
	"Login faster with fingerprint or face ID": "Gyorsabb bejelentkezés ujjlenyomattal vagy arcazonosítással",
	"Security Settings": "Biztonsági beállítások",
	"Post visibility": "Bejegyzés láthatósága",
	"Default visibility for new posts": "Új bejegyzések alapértelmezett láthatósága",
	"Followers": "Követők",
	"Public": "Nyilvános",
	"Verified users": "Ellenőrzött felhasználók",
	"Connections of connections": "Kapcsolatok kapcsolatai",
	"Subscribers": "Feliratkozók",
	"You can change visibility for individual posts when creating them.": "Az egyes bejegyzések láthatóságát létrehozáskor módosíthatod.",
	"Allow others to follow you": "Követés engedélyezése másoktól",
	"When disabled, new follow requests will be rejected and your posts will only be visible to your connections.": "Kikapcsolt állapotban az új követési kérelmek elutasításra kerülnek és a bejegyzéseid csak a kapcsolataid számára lesznek láthatók.",
	"Passkey added": "Jelkulcs hozzáadva",
	"Your passkey has been registered successfully.": "A jelkulcsod sikeresen regisztrálva lett.",
	"Failed to add passkey": "Nem sikerült hozzáadni a jelkulcsot",
	"Delete passkey?": "Jelkulcs törlése?",
	"This passkey will be permanently removed. You may lose access to your account if this is your only authentication method.": "Ez a jelkulcs véglegesen eltávolításra kerül. Elveszítheted a hozzáférést a fiókodhoz, ha ez az egyetlen hitelesítési módszered.",
	"Failed to delete passkey": "Nem sikerült törölni a jelkulcsot",
	"Delete API key?": "API kulcs törlése?",
	"This is the API key for this device. Deleting it will log you out on next visit.": "Ez az eszköz API kulcsa. Törlése kijelentkeztet a következő látogatáskor.",
	"This API key will be permanently revoked.": "Ez az API kulcs véglegesen visszavonásra kerül.",
	"Failed to delete API key": "Nem sikerült törölni az API kulcsot",
	"Enable stay logged in?": "Bejelentkezve maradás engedélyezése?",
	"This will create an API key stored on this device. Only use this on trusted devices. Anyone with access to this device will be able to access your account.": "Ez létrehoz egy API kulcsot ezen az eszközön. Csak megbízható eszközökön használd. Bárki, aki hozzáfér ehhez az eszközhöz, hozzáférhet a fiókodhoz.",
	"Failed to create API key": "Nem sikerült létrehozni az API kulcsot",
	"Password changed": "Jelszó megváltoztatva",
	"Your password has been changed successfully.": "A jelszavad sikeresen megváltoztatva.",
	"Passkeys": "Jelkulcsok",
	"Use biometric authentication or security keys for passwordless login.": "Használj biometrikus hitelesítést vagy biztonsági kulcsokat jelszó nélküli bejelentkezéshez.",
	"Passkey name (optional)": "Jelkulcs neve (opcionális)",
	"Add passkey": "Jelkulcs hozzáadása",
	"Stay logged in": "Bejelentkezve maradás",
	"Keep me logged in on this device": "Maradjak bejelentkezve ezen az eszközön",
	"Only enable this on personal, trusted devices. The login credentials will be stored locally.": "Csak személyes, megbízható eszközökön engedélyezd. A bejelentkezési adatok helyileg tárolódnak.",
	"API Keys": "API kulcsok",
	"API keys allow programmatic access or keeping devices logged in. Revoking a key will revoke its access.": "Az API kulcsok programozott hozzáférést vagy eszközök bejelentkezve maradását teszik lehetővé. Egy kulcs visszavonása megszünteti annak hozzáférését.",
	"Unnamed key": "Névtelen kulcs",
	"this device": "ez az eszköz",
	"Edit API key": "API kulcs szerkesztése",
	"Delete API key": "API kulcs törlése",
	"Name (optional)": "Név (opcionális)",
	"Expires (optional)": "Lejárat (opcionális)",
	"Permissions": "Engedélyek",
	"Leave all unchecked for full access.": "Hagyd üresen az összes jelölőnégyzetet a teljes hozzáféréshez.",
	"Save changes": "Módosítások mentése",
	"Key is valid until the end of this day.": "A kulcs a nap végéig érvényes.",
	"No expiration — the key is valid until revoked.": "Nincs lejárat — a kulcs visszavonásig érvényes.",
	"Failed to update API key": "Nem sikerült frissíteni az API kulcsot",
	"Expires {{date}}": "Lejár: {{date}}",
	"Expired {{date}}": "Lejárt: {{date}}",
	"Administration": "Adminisztráció",
	"Email Not Configured": "Email nincs beállítva",
	"Password resets and email notifications will not work": "A jelszó visszaállítások és email értesítések nem fognak működni",
	"Configure": "Beállítás",
	"Overview": "Áttekintés",
	"Profiles": "Profilok",
	"Administrator": "Adminisztrátor",
	"Community": "Közösség",
	"Community invitation": "Közösségi meghívó",
	"Person": "Személy",
	"Created": "Létrehozva",
	"Status": "Állapot",
	"Active": "Aktív",
	"No email address set": "Nincs email cím beállítva",
	"Failed to load tenants": "Nem sikerült betölteni a bérlőket",
	"Send Password Reset Email": "Jelszó visszaállító email küldése",
	"Are you sure you want to send a password reset email to the owner of {{idTag}}?": "Biztosan küldeni akarsz jelszó visszaállító emailt a(z) {{idTag}} tulajdonosának?",
	"Password Reset Email Sent": "Jelszó visszaállító email elküldve",
	"Failed to send password reset email": "Nem sikerült elküldeni a jelszó visszaállító emailt",
	"Search tenants...": "Bérlők keresése...",
	"No tenants found": "Nem található bérlő",
	"Delete tenant": "Bérlő törlése",
	"Type the tenant ID to confirm": "Megerősítéshez írd be a bérlő azonosítóját",
	"Type {{idTag}} below to confirm immediate deletion.": "Az azonnali törlés megerősítéséhez írd be lent: {{idTag}}.",
	"Tenant deleted": "Bérlő törölve",
	"Delete failed": "A törlés meghiúsult",
	"Users & Communities": "Felhasználók és közösségek",
	"Suggested Providers": "Javasolt szolgáltatók",
	"Registration": "Regisztráció",
	"Provider Settings": "Szolgáltató beállítások",
	"These providers appear as suggestions during registration. Users can still register with any identity provider.": "Ezek a szolgáltatók javaslatként jelennek meg regisztrációkor. A felhasználók bármely azonosító szolgáltatóval regisztrálhatnak.",
	"No suggested providers configured yet": "Még nincsenek beállított javasolt szolgáltatók",
	"Default Policies": "Alapértelmezett beállítások",
	"User Management": "Felhasználó kezelés",
	"System": "Rendszer",
	"Server Settings": "Szerver beállítások",
	"Configure server-wide settings and policies": "Szerver-szintű beállítások és házirendek konfigurálása",
	"Personal Settings": "Személyes beállítások",
	"Configure your personal account settings": "Személyes fiók beállítások konfigurálása",
	"Identities": "Azonosítók",
	"Started following you": "Követni kezdett",
	"Sent you a message": "Üzenetet küldött neked",
	"Commented on your post": "Hozzászólt a bejegyzésedhez",
	"Reacted to your post": "Reagált a bejegyzésedre",
	"Mentioned you": "Megemlített téged",
	"Published a new post": "Új bejegyzést tett közzé",
	"New notification": "Új értesítés",
	"All caught up!": "Nincs több értesítés!",
	"You have no new notifications.": "Nincs új értesítésed.",
	"See all": "Összes megtekintése",
	"No new notifications": "Nincs új értesítés",
	"Disconnected": "Szétkapcsolt",
	"Shared a file": "Fájlt osztott meg",
	"Authentication failed": "Hitelesítés sikertelen",
	"Access denied": "Hozzáférés megtagadva",
	"Document not found": "Dokumentum nem található",
	"Reverse Proxy": "Reverse Proxy",
	"Create Proxy Site": "Proxy oldal létrehozása",
	"Backend URL": "Backend URL",
	"Type": "Típus",
	"Basic": "Alap",
	"Advanced": "Haladó",
	"Configuration": "Konfiguráció",
	"Connect Timeout (seconds)": "Kapcsolat időtúllépés (másodperc)",
	"Read Timeout (seconds)": "Olvasási időtúllépés (másodperc)",
	"Preserve Host Header": "Host fejléc megtartása",
	"Forward Headers": "Fejlécek továbbítása",
	"WebSocket Support": "WebSocket támogatás",
	"Proxy Protocol": "Proxy protokoll",
	"Custom Headers": "Egyéni fejlécek",
	"One header per line: Name: Value": "Soronként egy fejléc: Név: Érték",
	"Failed to create proxy site": "Nem sikerült létrehozni a proxy oldalt",
	"Failed to update proxy site": "Nem sikerült frissíteni a proxy oldalt",
	"TLS Certificate": "TLS tanúsítvány",
	"Renew": "Megújítás",
	"No certificate": "Nincs tanúsítvány",
	"Saving...": "Mentés...",
	"Save": "Mentés",
	"Loading proxy sites...": "Proxy oldalak betöltése...",
	"Search by domain or backend URL...": "Keresés domain vagy backend URL alapján...",
	"Search proxy sites": "Proxy oldalak keresése",
	"No proxy sites matching \"{{query}}\"": "Nincs a(z) \"{{query}}\" kifejezésnek megfelelő proxy oldal",
	"No {{status}} proxy sites": "Nincs {{status}} proxy oldal",
	"Clear filters": "Szűrők törlése",
	"No proxy sites yet": "Még nincsenek proxy oldalak",
	"Create your first proxy site to start reverse proxying.": "Hozd létre az első proxy oldalt a reverse proxyzás megkezdéséhez.",
	"Delete {{domain}}?": "Törlöd a(z) {{domain}} oldalt?",
	"This will permanently delete this proxy site configuration. This action cannot be undone.": "Ez véglegesen törli a proxy oldal konfigurációját. Ez a művelet nem vonható vissza.",
	"Renew certificate?": "Tanúsítvány megújítása?",
	"This will trigger a certificate renewal for {{domain}}.": "Ez elindítja a tanúsítvány megújítását a(z) {{domain}} számára.",
	"Domain": "Domain",
	"Edit": "Szerkesztés",
	"active": "aktív",
	"disabled": "kikapcsolt",
	"Please enter a valid HTTP or HTTPS URL": "Kérlek adj meg egy érvényes HTTP vagy HTTPS URL-t",
	"Enabled": "Engedélyezve",
	"My Card": "Névjegyem",
	"Copy identity tag": "Azonosító másolása",
	"Copied!": "Másolva!",
	"Scan QR": "QR beolvasás",
	"Scan QR Code": "QR kód beolvasása",
	"Scan QR code": "QR kód beolvasása",
	"Not a Cloudillo QR code": "Nem Cloudillo QR kód",
	"Camera access denied": "Kamera hozzáférés megtagadva",
	"Invited you to create a community": "Meghívott egy közösség létrehozására",
	"Select an invitation": "Válassz meghívót",
	"Community creation requires an invitation from a server administrator.": "Közösség létrehozásához szerver adminisztrátori meghívó szükséges.",
	"Loading invitations...": "Meghívók betöltése...",
	"Use this invite": "Meghívó használata",
	"You don't have any community creation invites yet. Ask your server administrator for one.": "Még nincs közösség létrehozásra szóló meghívód. Kérj egyet a szerver adminisztrátortól.",
	"Send community invite": "Közösségi meghívó küldése",
	"Target user": "Célfelhasználó",
	"Message (optional)": "Üzenet (opcionális)",
	"Optional message for the recipient": "Opcionális üzenet a címzettnek",
	"Expires in": "Lejárat",
	"{{count}} days_one": "{{count}} nap",
	"{{count}} days_other": "{{count}} nap",
	"Send invite": "Meghívó küldése",
	"No community invitations yet.": "Még nincsenek közösségi meghívók.",
	"expires": "lejárat",
	"Used": "Felhasznált",
	"Join community": "Csatlakozás a közösséghez",
	"Do you want to join this community?": "Csatlakozni szeretnél ehhez a közösséghez?",
	"Join request": "Csatlakozási kérelem",
	"Send a join request to this community?": "Csatlakozási kérelmet küldeni a közösségnek?",
	"Join": "Csatlakozás",
	"Authenticate to {{idTag}}?": "Azonosítás: {{idTag}}?",
	"You are browsing anonymously. Authenticating lets them see you viewed them and unlocks content restricted to known viewers.": "Névtelenül böngészel. Ha azonosítod magad, láthatják, hogy megnézted a profiljukat, és elérhetővé válik az ismerős nézőknek szánt tartalom is.",
	"This session": "Ebben a munkamenetben",
	"Always": "Mindig",
	"Continue anonymously": "Maradok névtelen",
	"Anonymous": "Névtelen",
	"Anonymous (session)": "Névtelen (munkamenet)",
	"Session auth": "Munkamenet",
	"Failed to update trust preference": "A bizalmi beállítás frissítése sikertelen",
	"Failed to load trusted profiles": "A megbízott profilok betöltése sikertelen",
	"Trusted": "Megbízott",
	"Trusted profiles": "Megbízott profilok",
	"No trusted profiles": "Nincs megbízott profil",
	"You have not marked any profiles as Always or Never. Open a profile page to set a preference.": "Nem jelöltél még meg profilt Mindig vagy Soha értékkel. Nyiss meg egy profilt a beállításhoz.",
	"Clear trust": "Beállítás törlése",
	"Ask": "Kérdés",
	"Trust preference": "Bizalmi beállítás",
	"Contacts": "Névjegyek",
	"All contacts": "Összes névjegy",
	"Address book": "Címjegyzék",
	"New address book": "Új címjegyzék",
	"Rename address book": "Címjegyzék átnevezése",
	"Delete address book?": "Törlöd a címjegyzéket?",
	"All contacts in \"{{name}}\" will be permanently removed.": "A(z) \"{{name}}\" minden névjegye véglegesen törlődik.",
	"No address books yet": "Még nincs címjegyzéked",
	"Create an address book to start adding contacts.": "Hozz létre címjegyzéket, hogy névjegyeket adhass hozzá.",
	"Search contacts": "Keresés a névjegyek között",
	"New contact": "Új névjegy",
	"Edit contact": "Névjegy szerkesztése",
	"Delete contact?": "Törlöd a névjegyet?",
	"\"{{name}}\" will be permanently removed.": "A(z) \"{{name}}\" véglegesen törlődik.",
	"Contact updated": "Névjegy frissítve",
	"Contact created": "Névjegy létrehozva",
	"Contact deleted": "Névjegy törölve",
	"Contact added from your network": "Névjegy hozzáadva a hálózatodból",
	"Loading contacts...": "Névjegyek betöltése...",
	"Loading more contacts...": "További névjegyek betöltése...",
	"No contacts": "Nincs névjegy",
	"Create a contact or add one from your Cloudillo network.": "Hozz létre egy névjegyet, vagy adj hozzá egyet a Cloudillo hálózatodból.",
	"Select a contact to see details": "Válassz ki egy névjegyet a részletekhez",
	"Add from Cloudillo network": "Hozzáadás a Cloudillo hálózatból",
	"Search profiles": "Profilok keresése",
	"Name or idTag": "Név vagy idTag",
	"No matching profiles": "Nincs találat",
	"Searching...": "Keresés...",
	"Adding...": "Hozzáadás...",
	"Failed to add contact": "Nem sikerült a névjegy hozzáadása",
	"Search failed": "A keresés sikertelen",
	"Linked Cloudillo profile": "Kapcsolt Cloudillo profil",
	"Linked Cloudillo profile (idTag)": "Kapcsolt Cloudillo profil (idTag)",
	"Links this contact to a Cloudillo profile so name and photo stay live.": "A névjegyet Cloudillo profilhoz köti, így a név és a kép mindig naprakész marad.",
	"Display name (auto-derived if empty)": "Megjelenített név (ha üres, automatikus)",
	"Given": "Keresztnév",
	"Family": "Vezetéknév",
	"Photo URL": "Fotó URL",
	"Notes": "Megjegyzés",
	"Provide at least a name": "Adj meg legalább egy nevet",
	"Failed to save contact": "Nem sikerült a névjegy mentése",
	"Failed to save address book": "Nem sikerült a címjegyzék mentése",
	"Failed to delete contact": "Nem sikerült a névjegy törlése",
	"Name": "Név",
	"Name is required": "A név megadása kötelező",
	"Description (optional)": "Leírás (nem kötelező)",
	"Phone": "Telefon",
	"other": "egyéb",
	"Add email": "Email hozzáadása",
	"Add phone": "Telefon hozzáadása",
	"Remove email": "Email törlése",
	"Remove phone": "Telefon törlése",
	"Email type": "Email típusa",
	"Phone type": "Telefon típusa",
	"Select an address book": "Válassz címjegyzéket",
	"Show address books": "Címjegyzékek megjelenítése",
	"Create": "Létrehozás",
	"Retry": "Újrapróbálkozás",
	"Organization": "Szervezet",
	"Title": "Beosztás",
	"e.g., Personal": "pl. Személyes",
	"e.g., CI pipeline": "pl. CI pipeline",
	"Failed to load:": "Betöltés sikertelen:",
	"Image failed to load": "A kép betöltése sikertelen",
	"Not connected": "Nincs kapcsolat",
	"CardDAV (read)": "CardDAV (olvasás)",
	"Read contacts via CardDAV (Apple Contacts, Thunderbird, DAVx⁵).": "Névjegyek olvasása CardDAV-n keresztül (Apple Contacts, Thunderbird, DAVx⁵).",
	"CardDAV (read/write)": "CardDAV (olvasás/írás)",
	"Read and modify contacts via CardDAV. Implies CardDAV (read).": "Névjegyek olvasása és módosítása CardDAV-n keresztül. Magában foglalja a CardDAV (olvasás) jogot.",
	"CalDAV (read)": "CalDAV (olvasás)",
	"Read calendars via CalDAV (Apple Calendar, Thunderbird, DAVx⁵).": "Naptárak olvasása CalDAV-n keresztül (Apple Calendar, Thunderbird, DAVx⁵).",
	"CalDAV (read/write)": "CalDAV (olvasás/írás)",
	"Read and modify calendars via CalDAV. Implies CalDAV (read).": "Naptárak olvasása és módosítása CalDAV-n keresztül. Magában foglalja a CalDAV (olvasás) jogot.",
	"Connect a DAV client": "DAV kliens csatlakoztatása",
	"CardDAV (contacts)": "CardDAV (névjegyek)",
	"CalDAV (calendars)": "CalDAV (naptárak)",
	"Server URL": "Szerver URL",
	"Coming soon": "Hamarosan",
	"Server support not yet available": "A szerveroldali támogatás még nem elérhető",
	"Apple Contacts → Internet Accounts → Other / Thunderbird → Address Book → New CardDAV / DAVx⁵ → Add account.": "Apple Contacts → Internet Accounts → Other / Thunderbird → Címjegyzék → Új CardDAV / DAVx⁵ → Fiók hozzáadása.",
	"Apple Calendar → Add Account → Other / Thunderbird → New Calendar → On the Network / DAVx⁵ → Add account.": "Apple Calendar → Fiók hozzáadása → Egyéb / Thunderbird → Új naptár → A hálózaton / DAVx⁵ → Fiók hozzáadása.",
	"Any value works — the server ignores the username.": "Bármilyen érték megfelel — a szerver figyelmen kívül hagyja a felhasználónevet.",
	"Copy {{label}}": "{{label}} másolása",
	"server URL": "szerver URL",
	"username": "felhasználónév",
	"password": "jelszó",
	"Import contacts (VCF)": "Névjegyek importálása (VCF)",
	"No vCard blocks detected": "Nem találtunk vCard blokkot",
	"If a contact already exists": "Ha már létezik a névjegy",
	"Skip duplicates": "Duplikátumok kihagyása",
	"Keep existing contacts unchanged. New ones are added.": "A meglévő névjegyek változatlanok maradnak. Az újak hozzáadódnak.",
	"Replace duplicates": "Duplikátumok felülírása",
	"Overwrite existing contacts with the imported version.": "A meglévő névjegyek felülíródnak az importált verzióval.",
	"Add as new": "Hozzáadás újként",
	"Always create a new contact, even if one with the same UID exists.": "Mindig új névjegyet hoz létre, akkor is, ha azonos UID-vel már létezik.",
	"Import": "Importálás",
	"Importing...": "Importálás...",
	"Could not read file": "Nem sikerült beolvasni a fájlt",
	"Import failed": "Az importálás sikertelen",
	"Import complete": "Az importálás befejeződött",
	"Import finished with errors": "Az importálás hibákkal fejeződött be",
	"{{imported}} added · {{updated}} updated · {{skipped}} skipped · {{errors}} failed": "{{imported}} hozzáadva · {{updated}} frissítve · {{skipped}} kihagyva · {{errors}} sikertelen",
	"{{imported}} added, {{updated}} updated, {{skipped}} skipped": "{{imported}} hozzáadva, {{updated}} frissítve, {{skipped}} kihagyva",
	"Show error details": "Hibák részletei",
	"More actions": "További műveletek",
	"More actions for {{name}}": "További műveletek: {{name}}",
	"Import VCF…": "VCF importálása…",
	"Drop a .vcf file here, or click to browse": "Húzd ide a .vcf fájlt, vagy kattints a tallózáshoz",
	"Exported from Apple Contacts, Google Contacts, etc.": "Exportálható az Apple Contacts, Google Contacts stb. alkalmazásból",
	"Replace file": "Fájl cseréje",
	"Replace": "Cserél",
	"Remove file": "Fájl eltávolítása",
	"Done": "Kész",
	"Calendar": "Naptár",
	"No calendars yet": "Még nincsenek naptárak",
	"Create a calendar to start adding events and tasks.": "Hozz létre egy naptárat, és kezdj eseményeket és feladatokat hozzáadni.",
	"New calendar": "Új naptár",
	"Edit calendar": "Naptár szerkesztése",
	"Delete calendar?": "Törlöd a naptárat?",
	"All events and tasks in \"{{name}}\" will be permanently removed.": "A(z) \"{{name}}\" naptárban lévő minden esemény és feladat véglegesen törlődik.",
	"Calendar created": "Naptár létrehozva",
	"Calendar updated": "Naptár frissítve",
	"Calendar deleted": "Naptár törölve",
	"Show {{name}}": "{{name}} megjelenítése",
	"Holds": "Tartalom",
	"Events": "Események",
	"Tasks": "Feladatok",
	"Colour": "Szín",
	"Select at least one of events or tasks.": "Legalább az események vagy a feladatok egyikét válaszd ki.",
	"Failed to save calendar": "Nem sikerült elmenteni a naptárat",
	"e.g., Work": "pl. Munka",
	"Pick a calendar": "Válassz egy naptárat",
	"Event": "Esemény",
	"New event": "Új esemény",
	"Edit event": "Esemény szerkesztése",
	"Delete event?": "Törlöd az eseményt?",
	"Event created": "Esemény létrehozva",
	"Event updated": "Esemény frissítve",
	"Failed to save event": "Nem sikerült elmenteni az eseményt",
	"When": "Mikor",
	"Starts": "Kezdés",
	"Ends": "Befejezés",
	"All day": "Egész nap",
	"Location": "Helyszín",
	"Organizer": "Szervező",
	"Attendees": "Résztvevők",
	"Recurrence": "Ismétlés",
	"Does not repeat": "Nem ismétlődik",
	"Daily": "Naponta",
	"Weekly": "Hetente",
	"Monthly": "Havonta",
	"Yearly": "Évente",
	"Custom…": "Egyéni…",
	"Recurring": "Ismétlődő",
	"Show original positions": "Eredeti helyek megjelenítése",
	"Show original positions for moved occurrences": "Áthelyezett ismétlődések eredeti helyének megjelenítése",
	"Failed to update setting": "Nem sikerült frissíteni a beállítást",
	"No time set": "Nincs beállítva időpont",
	"Could not fully parse this entry: {{err}}": "Nem sikerült teljesen feldolgozni ezt a bejegyzést: {{err}}",
	"Select an event or task to see details.": "Válassz egy eseményt vagy feladatot a részletekhez.",
	"Event title": "Esemény címe",
	"Event title is required": "Az esemény címe kötelező",
	"Task title": "Feladat címe",
	"Task title is required": "A feladat címe kötelező",
	"New task": "Új feladat",
	"Edit task": "Feladat szerkesztése",
	"Delete task?": "Törlöd a feladatot?",
	"Task created": "Feladat létrehozva",
	"Task updated": "Feladat frissítve",
	"Failed to save task": "Nem sikerült elmenteni a feladatot",
	"No tasks yet": "Még nincsenek feladatok",
	"No events in this range": "Ebben az időszakban nincsenek események",
	"Due": "Határidő",
	"Priority": "Prioritás",
	"High": "Magas",
	"Medium": "Közepes",
	"Low": "Alacsony",
	"Not started": "Nem kezdett",
	"In progress": "Folyamatban",
	"Completed": "Kész",
	"Mark complete": "Kijelölés készként",
	"Start time is required": "A kezdési idő kötelező",
	"This cannot be undone.": "Ez a művelet nem vonható vissza.",
	"Deleted": "Törölve",
	"Failed to delete": "Nem sikerült a törlés",
	"Month": "Hónap",
	"Week": "Hét",
	"Day": "Nap",
	"Agenda": "Napirend",
	"Today": "Ma",
	"Previous": "Előző",
	"Next": "Következő",
	"Previous month": "Előző hónap",
	"Next month": "Következő hónap",
	"Search events": "Események keresése",
	"(untitled)": "(névtelen)",
	"Invite only": "Csak meghívóval",
	"Anyone can join immediately.": "Bárki azonnal csatlakozhat.",
	"Connection requests are auto-rejected. Members can only join via an invitation from a leader or moderator.": "A kapcsolatfelvételi kérelmeket automatikusan elutasítjuk. A tagok csak vezető vagy moderátor által küldött meghívóval csatlakozhatnak.",
	"A leader or moderator must approve each connection request.": "Minden kapcsolatfelvételi kérelmet egy vezetőnek vagy moderátornak jóvá kell hagynia.",
	"Requests": "Kérelmek",
	"No pending requests.": "Nincs függőben lévő kérelem.",
	"No invitations sent.": "Nincs elküldött meghívó.",
	"No pending requests": "Nincs függőben lévő kérelem",
	"No invitations sent": "Nincs elküldött meghívó",
	"Pending requests": "Függőben lévő kérelmek",
	"Approve": "Elfogadás",
	"Revoke invitation": "Meghívó visszavonása",
	"+ Invite members": "+ Tagok meghívása",
	"Invite members": "Tagok meghívása",
	"Optional message": "Opcionális üzenet",
	"Invitation revoked": "Meghívó visszavonva",
	"Request sent": "Kérés elküldve",
	"Request approved": "Kérelem elfogadva",
	"Request rejected": "Kérelem elutasítva",
	"Pending": "Függőben",
	"invited by {{name}}": "meghívta: {{name}}",
	"Are you sure you want to approve this request?": "Biztos elfogadod ezt a kérelmet?",
	"Are you sure you want to reject this request?": "Biztos elutasítod ezt a kérelmet?",
	"Are you sure you want to revoke this invitation?": "Biztos visszavonod ezt a meghívót?",
	"Failed to load requests": "Nem sikerült betölteni a kérelmeket",
	"Failed to load invitations": "Nem sikerült betölteni a meghívókat",
	"Failed to load members": "Nem sikerült betölteni a tagokat",
	"Failed to send invitation": "Nem sikerült elküldeni a meghívót",
	"{{sent}} invitations sent, {{failed}} failed": "{{sent}} meghívó elküldve, {{failed}} sikertelen",
	"Failed to delete invitation": "Nem sikerült törölni a meghívót",
	"app.loading.error": "Failed to load app",
	"app.loading.connecting": "Connecting...",
	"app.loading.syncing": "Syncing...",
	"app.loading.retry": "Retry",
	"Failed to load event": "Esemény betöltése sikertelen",
	"Reset to series default": "Visszaállítás a sorozat alapértékére",
	"Reset failed": "Visszaállítás sikertelen",
	"Failed to update task": "Feladat frissítése sikertelen",
	"Toggle calendars": "Naptárak ki-/bekapcsolása",
	"My calendars": "Saját naptáraim",
	"Hide {{name}}": "{{name}} elrejtése",
	"Calendar view": "Naptárnézet",
	"{{n}} minutes": "{{n}} perc",
	"{{n}} hours": "{{n}} óra",
	"{{base}} — ends {{end}}": "{{base}} — vége: {{end}}",
	"End date must be on or after the start date": "A befejezés dátumának a kezdés dátumán vagy után kell lennie",
	"End time is invalid": "A befejezés időpontja érvénytelen",
	"End time must be after the start time": "A befejezés időpontjának a kezdés után kell lennie",
	"Start date": "Kezdés dátuma",
	"Start time": "Kezdés időpontja",
	"End date": "Befejezés dátuma",
	"Duration": "Időtartam",
	"Custom end time…": "Egyéni befejezési idő…",
	"End time": "Befejezés időpontja",
	"Ends {{when}}": "Vége: {{when}}",
	"Repeat": "Ismétlés",
	"Where & details": "Helyszín és részletek",
	"Press Enter or comma to add": "A hozzáadáshoz nyomj Entert vagy vesszőt",
	"Alerts": "Riasztások",
	"Reminder": "Emlékeztető",
	"5 minutes before": "5 perccel előtte",
	"15 minutes before": "15 perccel előtte",
	"30 minutes before": "30 perccel előtte",
	"1 hour before": "1 órával előtte",
	"1 day before": "1 nappal előtte",
	"1 week before": "1 héttel előtte",
	"Normal": "Normál",
	"To do": "Tennivaló",
	"Cancelled": "Lemondva",
	"Confirmed": "Megerősítve",
	"Tentative": "Tervezett",
	"Details": "Részletek",
	"Custom rule": "Egyéni szabály",
	"This occurrence has been modified.": "Ez az előfordulás módosítva lett.",
	"day": "nap",
	"days": "nap",
	"week": "hét",
	"weeks": "hét",
	"month": "hónap",
	"months": "hónap",
	"year": "év",
	"Every": "Minden",
	"Interval": "Időköz",
	"On": "Bekapcsolva",
	"Repeat on days": "Ismétlődési napok",
	"Monthly pattern": "Havi minta",
	"On day": "Adott napon",
	"Day of month": "A hónap napja",
	"On the": "Ekkor:",
	"first": "első",
	"second": "második",
	"third": "harmadik",
	"fourth": "negyedik",
	"last": "utolsó",
	"On {{date}}": "{{date}} napon",
	"Never ends": "Soha nem ér véget",
	"After": "Után",
	"Number of occurrences": "Előfordulások száma",
	"occurrences": "előfordulás",
	"Custom RRULE": "Egyéni RRULE",
	"Delete recurring event": "Ismétlődő esemény törlése",
	"Edit recurring event": "Ismétlődő esemény szerkesztése",
	"This event repeats. Which occurrences should be deleted?": "Ez az esemény ismétlődik. Mely előfordulásokat törlöd?",
	"This event repeats. Which occurrences should the changes apply to?": "Ez az esemény ismétlődik. Mely előfordulásokra vonatkozzanak a módosítások?",
	"Scope": "Hatókör",
	"This event only": "Csak ez az esemény",
	"Only the occurrence on {{date}}": "Csak a(z) {{date}} napi előfordulás",
	"This and following events": "Ez és a következő események",
	"All occurrences from {{date}} onward": "Minden előfordulás {{date}}-tól kezdve",
	"All events in the series": "A sorozat összes eseménye",
	"Every occurrence, past and future": "Minden előfordulás, múlt és jövő",
	"Some calendars failed to load": "Néhány naptár betöltése sikertelen",
	"Update failed": "Frissítés sikertelen",
	"Every day": "Minden nap",
	"Every {{n}} days": "{{n}} naponta",
	"Every weekday": "Minden hétköznap",
	"Weekly on {{days}}": "Hetente: {{days}}",
	"Every {{n}} weeks on {{days}}": "{{n}} hetente: {{days}}",
	"Every week": "Minden héten",
	"Every {{n}} weeks": "{{n}} hetente",
	"Monthly on day {{d}}": "Havonta a(z) {{d}}. napon",
	"Every {{n}} months on day {{d}}": "{{n}} havonta a(z) {{d}}. napon",
	"Every month": "Minden hónapban",
	"Every {{n}} months": "{{n}} havonta",
	"Yearly on {{date}}": "Évente: {{date}}",
	"Every {{n}} years on {{date}}": "{{n}} évente: {{date}}",
	"Every year": "Minden évben",
	"Every {{n}} years": "{{n}} évente",
	"{{rule}}, {{n}} times": "{{rule}}, {{n}} alkalom",
	"{{rule}}, until {{date}}": "{{rule}}, eddig: {{date}}",
	"{{count}} contacts found_one": "{{count}} névjegy található",
	"{{count}} contacts found_other": "{{count}} névjegy található",
	"What's on your mind?": "Mire gondolsz?",
	"Search posts...": "Bejegyzések keresése...",
	"Drafts": "Piszkozatok",
	"Mark all as read": "Összes megjelölése olvasottként",
	"Caught up": "Mindent elolvastál",
	"Loading more posts...": "További bejegyzések betöltése...",
	"Editing scheduled post": "Ütemezett bejegyzés szerkesztése",
	"Editing draft": "Piszkozat szerkesztése",
	"Scheduled post updated": "Ütemezett bejegyzés frissítve",
	"Draft saved": "Piszkozat mentve",
	"Keep as draft?": "Megtartod piszkozatként?",
	"You have unsaved content.": "Nem mentett tartalmad van.",
	"Update schedule": "Ütemezés frissítése",
	"Schedule post": "Bejegyzés ütemezése",
	"Schedule": "Ütemezés",
	"Poll": "Szavazás",
	"This post is scheduled for {{date}}. Publish immediately instead?": "Ez a bejegyzés {{date}}-ra van ütemezve. Inkább azonnal közzéteszed?",
	"Publish this post immediately?": "Azonnal közzéteszed ezt a bejegyzést?",
	"Publish now": "Közzététel most",
	"Delete scheduled post": "Ütemezett bejegyzés törlése",
	"Delete draft": "Piszkozat törlése",
	"Delete this scheduled post? This cannot be undone.": "Törlöd ezt az ütemezett bejegyzést? Ez nem vonható vissza.",
	"Delete this draft? This cannot be undone.": "Törlöd ezt a piszkozatot? Ez nem vonható vissza.",
	"Schedule overdue": "Ütemezés lejárt",
	"SCHEDULED": "ÜTEMEZETT",
	"DRAFT": "PISZKOZAT",
	"Last edited:": "Utoljára szerkesztve:",
	"No text": "Nincs szöveg",
	"video": "videó",
	"document": "dokumentum",
	"image": "kép",
	"images": "kép",
	"Empty draft": "Üres piszkozat",
	"Unschedule": "Ütemezés visszavonása",
	"No drafts or scheduled posts": "Nincsenek piszkozatok vagy ütemezett bejegyzések",
	"Posts you save or schedule will appear here.": "Az általad mentett vagy ütemezett bejegyzések itt jelennek meg.",
	"{{count}} new posts_one": "{{count}} új bejegyzés",
	"{{count}} new posts_other": "{{count}} új bejegyzés",
	"Delete post": "Bejegyzés törlése",
	"Delete this post? This cannot be undone.": "Törlöd ezt a bejegyzést? Ez nem vonható vissza.",
	"in the past": "a múltban",
	"in {{count}} minutes_one": "{{count}} perc múlva",
	"in {{count}} minutes_other": "{{count}} perc múlva",
	"in {{count}} hours_one": "{{count}} óra múlva",
	"in {{count}} hours_other": "{{count}} óra múlva",
	"in {{count}} days_one": "{{count}} nap múlva",
	"in {{count}} days_other": "{{count}} nap múlva",
	"Publish on": "Közzététel:",
	"Schedule date": "Ütemezés dátuma",
	"Schedule time": "Ütemezés időpontja",
	"Clear schedule": "Ütemezés törlése",
	"Open with...": "Megnyitás ezzel...",
	"Remove star": "Csillag eltávolítása",
	"Add star": "Csillagozás",
	"Remove star from {{count}} items_one": "Csillag eltávolítása {{count}} elemről",
	"Remove star from {{count}} items_other": "Csillag eltávolítása {{count}} elemről",
	"Add star to {{count}} items_one": "Csillag hozzáadása {{count}} elemhez",
	"Add star to {{count}} items_other": "Csillag hozzáadása {{count}} elemhez",
	"Unpin": "Rögzítés feloldása",
	"Pin to top": "Rögzítés legfelülre",
	"Unpin {{count}} items_one": "{{count}} elem rögzítésének feloldása",
	"Unpin {{count}} items_other": "{{count}} elem rögzítésének feloldása",
	"Pin {{count}} items to top_one": "{{count}} elem rögzítése legfelülre",
	"Pin {{count}} items to top_other": "{{count}} elem rögzítése legfelülre",
	"Duplicate": "Másolat",
	"Link removed": "Hivatkozás eltávolítva",
	"Failed to remove link": "Hivatkozás eltávolítása sikertelen",
	"Starred": "Csillagozott",
	"Star": "Csillag",
	"Pinned": "Rögzítve",
	"Pin": "Rögzítés",
	"Last opened": "Utoljára megnyitva",
	"Last edited": "Utoljára szerkesztve",
	"Show QR code": "QR-kód megjelenítése",
	"Remove link": "Hivatkozás eltávolítása",
	"Remove type filter": "Típus szűrő eltávolítása",
	"Owner: Me": "Tulajdonos: Én",
	"Owner: Others": "Tulajdonos: Mások",
	"Remove owner filter": "Tulajdonos szűrő eltávolítása",
	"Remove search filter": "Keresés szűrő eltávolítása",
	"Remove tag filter": "Címke szűrő eltávolítása",
	"Remove room filter": "Szoba szűrő eltávolítása",
	"Import file": "Fájl importálása",
	"This file can be converted to a native document:": "Ez a fájl natív dokumentummá konvertálható:",
	"Convert to {{appName}}": "Konvertálás: {{appName}}",
	"Upload as file": "Feltöltés fájlként",
	"{{count}} more file(s) to process_one": "Még {{count}} feldolgozandó fájl",
	"{{count}} more file(s) to process_other": "Még {{count}} feldolgozandó fájl",
	"Live document": "Élő dokumentum",
	"Has unsynced local edits": "Nem szinkronizált helyi módosítások",
	"Unstar": "Csillag eltávolítása",
	"Remove this link?": "Eltávolítod ezt a hivatkozást?",
	"Notillo wiki": "Notillo wiki",
	"Scanillo document scanner": "Scanillo dokumentumszkenner",
	"Browse": "Tallózás",
	"Search files...": "Fájlok keresése...",
	"Search photos...": "Fotók keresése...",
	"Owner": "Tulajdonos",
	"Owner (you)": "Tulajdonos (te)",
	"Anyone": "Bárki",
	"Others": "Mások",
	"Copy of {{name}}": "{{name}} másolata",
	"Provide a name for the duplicate": "Adj nevet a másolatnak",
	"File duplicated": "Fájl megkettőzve",
	"Failed to duplicate file": "Fájl megkettőzése sikertelen",
	"Refresh metadata": "Metaadatok frissítése",
	"File metadata refreshed": "Fájl metaadatok frissítve",
	"Failed to refresh file metadata": "A metaadatok frissítése sikertelen",
	"No starred files yet": "Még nincsenek csillagozott fájlok",
	"Star files to quickly access them later": "Csillagozz fájlokat, hogy később gyorsan elérhesd őket",
	"Loading more files...": "További fájlok betöltése...",
	"Active filters:": "Aktív szűrők:",
	"Remove filter": "Szűrő eltávolítása",
	"Remove tag": "Címke eltávolítása",
	"Showing {{filtered}} of {{total}} photos": "{{filtered}} / {{total}} fénykép megjelenítve",
	"All photos": "Minden fénykép",
	"Time": "Idő",
	"All time": "Bármikor",
	"This week": "Ezen a héten",
	"This month": "Ebben a hónapban",
	"This year": "Ebben az évben",
	"Toggle filters": "Szűrők ki-/bekapcsolása",
	"Justified rows layout": "Sorkizárt elrendezés",
	"Masonry layout": "Téglafal elrendezés",
	"No photos match your filters": "Egyetlen fénykép sem felel meg a szűrőknek",
	"Try adjusting your filters to see more photos": "Módosítsd a szűrőket, hogy több fényképet láss",
	"Loading more images...": "További képek betöltése...",
	"Failed to load PDF": "PDF betöltése sikertelen",
	"Fit width": "Szélességhez igazítás",
	"Fit": "Igazítás",
	"Scan QR code to log in": "Olvasd be a QR-kódot a bejelentkezéshez",
	"Waiting for approval...": "Jóváhagyásra várva...",
	"Login approved": "Bejelentkezés jóváhagyva",
	"Login denied": "Bejelentkezés elutasítva",
	"QR code expired": "QR-kód lejárt",
	"Click to refresh": "Kattints a frissítéshez",
	"Failed to generate QR code": "QR-kód generálása sikertelen",
	"Access temporarily blocked. Please wait a moment before trying again.": "A hozzáférés átmenetileg letiltva. Kérlek várj egy kicsit, mielőtt újra próbálkozol.",
	"Connection lost. Please try again.": "A kapcsolat megszakadt. Kérlek, próbáld újra.",
	"Capture Photo": "Fénykép készítése",
	"Select document": "Dokumentum kiválasztása",
	"Select": "Kiválasztás",
	"Search documents...": "Dokumentumok keresése...",
	"No documents found": "Nem található dokumentum",
	"Join as Guest": "Csatlakozás vendégként",
	"Enter a name that other collaborators will see": "Add meg a nevet, amelyet más közreműködők látni fognak",
	"Images": "Képek",
	"Videos": "Videók",
	"Audio": "Hang",
	"PDF documents": "PDF dokumentumok",
	"Select media": "Média kiválasztása",
	"Grant access": "Hozzáférés megadása",
	"Make public": "Nyilvánossá tétel",
	"Only public documents can be embedded in a site page.": "Webhelyoldalba csak nyilvános dokumentum ágyazható be.",
	"Visibility mismatch": "Láthatósági eltérés",
	"This file is {{visibility}}. Some viewers may not be able to see this media.": "Ez a fájl {{visibility}}. Egyes nézők nem feltétlenül láthatják ezt a médiát.",
	"Updating...": "Frissítés...",
	"Use anyway": "Használat ennek ellenére",
	"Click to {{action}}": "Kattints: {{action}}",
	"Confirm": "Megerősítés",
	"Failed to read file": "Fájl beolvasása sikertelen",
	"Upload failed": "Feltöltés sikertelen",
	"Upload failed — invalid server response.": "Feltöltés sikertelen — érvénytelen szerverválasz.",
	"Optimizing image...": "Kép optimalizálása...",
	"Preparing image...": "Kép előkészítése...",
	"Session expired — please reload and try again.": "A munkamenet lejárt — kérjük, töltsd újra az oldalt és próbáld meg újra.",
	"You don't have permission to upload here.": "Nincs jogosultságod ide feltölteni.",
	"File is too large for this server.": "A fájl túl nagy ehhez a kiszolgálóhoz.",
	"Server error — please try again.": "Szerverhiba — kérjük, próbáld újra.",
	"Network error — check your connection.": "Hálózati hiba — ellenőrizd a kapcsolatot.",
	"Public visibility ensures all document viewers can see this file.": "A nyilvános láthatóság biztosítja, hogy minden néző láthatja ezt a fájlt.",
	"Only public files can be embedded. Some viewers may not see this file.": "Csak nyilvános fájlok ágyazhatók be. Egyes nézők nem fogják látni ezt a fájlt.",
	"Drag and drop a file here": "Húzz ide egy fájlt",
	"or click to browse": "vagy kattints a tallózáshoz",
	"Uploading...": "Feltöltés...",
	"Upload complete": "Feltöltés kész",
	"Click Select to use this file": "Kattints a Kiválasztásra a fájl használatához",
	"Upload another": "Másik feltöltése",
	"Browse folders": "Mappák böngészése",
	"Recent files": "Legutóbbi fájlok",
	"Starred files": "Csillagozott fájlok",
	"Filter by tags": "Szűrés címkék szerint",
	"Home": "Kezdőlap",
	"Failed to load files": "Fájlok betöltése sikertelen",
	"Session expired or invalid": "A munkamenet lejárt vagy érvénytelen",
	"Failed to respond": "Válaszadás sikertelen",
	"Unknown browser": "Ismeretlen böngésző",
	"Allow login from this device?": "Engedélyezed a bejelentkezést erről az eszközről?",
	"Deny": "Elutasítás",
	"Allow": "Engedélyezés",
	"View only": "Csak megtekintés",
	"Create share link": "Megosztási hivatkozás létrehozása",
	"Share this document": "Dokumentum megosztása",
	"Create new link": "Új hivatkozás létrehozása",
	"Use existing link": "Meglévő hivatkozás használata",
	"Shared link": "Megosztott hivatkozás",
	"Copy page link": "Oldal hivatkozásának másolása",
	"Create & copy link": "Hivatkozás létrehozása és másolása",
	"{{name}} (setting up)": "{{name}} (beállítás alatt)",
	"Failed to switch context. Please try again.": "Környezetváltás sikertelen. Kérlek próbáld újra.",
	"{{hat}} has no agreement with {{community}}": "{{hat}} nem áll megállapodásban ezzel: {{community}}",
	"Enter {{name}} as…": "Belépés ide: {{name}}, mint…",
	"Via {{name}}": "{{name}} tagjaként",
	"As yourself": "Saját magadként",
	"Forget {{name}}": "{{name}} elfelejtése",
	"Another community…": "Másik közösség…",
	"Partner communities": "Partnerközösségek",
	"Enter as {{name}} member": "Belépés {{name}} tagjaként",
	"Enter with this hat": "Belépés ezzel a kalappal",
	"Enter {{community}} via {{hat}}": "Belépés ide: {{community}}, {{hat}} tagjaként",
	"Change identity": "Identitás váltása",
	"{{community}} · via {{hat}}": "{{community}} · {{hat}} tagjaként",
	"Posting as": "Közzététel mint",
	"{{role}} here": "itt: {{role}}",
	"Change": "Váltás",
	"Members only — not open to partner communities": "Csak tagoknak — partnerközösségek számára nem nyitott",
	"Connect {{community}} with {{name}}": "{{community}} összekapcsolása ezzel: {{name}}",
	"Connect a community": "Közösség összekapcsolása",
	"Send a partnership request to {{name}}?": "Partnerségi kérelmet küldesz ide: {{name}}?",
	"Only leaders can manage partner communities.": "Csak vezetők kezelhetik a partnerközösségeket.",
	"No partner communities yet": "Még nincsenek partnerközösségek",
	"Partners' members can act here with the role you grant them.": "A partnerek tagjai az általad megadott szerepkörrel léphetnek itt.",
	"Their members here: {{roles}}": "Az ő tagjaik nálunk: {{roles}}",
	"Our members there: {{roles}}": "A mi tagjaink náluk: {{roles}}",
	"No access granted": "Nincs megadott hozzáférés",
	"Search communities...": "Közösségek keresése...",
	"Revoke all access": "Minden hozzáférés visszavonása",
	"{{name}}'s members will no longer be able to act here.": "{{name}} tagjai többé nem léphetnek itt.",
	"Disconnect from {{name}}? Hats between the two communities stop working.": "Bontod a kapcsolatot ezzel: {{name}}? A két közösség közötti kalapok megszűnnek.",
	"Their members' access here": "Az ő tagjaik hozzáférése nálunk",
	"Members of {{name}} can act in this community with a role you choose. Their role there decides which role they get here.": "A(z) {{name}} tagjai az általad választott szerepkörrel léphetnek ebben a közösségben. Az ottani szerepkörük dönti el, melyiket kapják itt.",
	"No access yet: set a role below.": "Még nincs hozzáférés: állíts be egy szerepkört lent.",
	"Gets {{role}}, same as {{from}}": "{{role}} szerepkört kap, mint {{from}}",
	"Role here for {{role}}": "Itteni szerepkör ennek: {{role}}",
	"Followers can't act with a hat.": "Követők nem léphetnek kalappal.",
	"No access has been granted yet": "Még nincs megadott hozzáférés",
	"Supporters": "Támogatók",
	"Contributors": "Közreműködők",
	"Moderators": "Moderátorok",
	"Leaders": "Vezetők",
	"{{role}} join here as {{local}}.": "{{role}} itt {{local}} szerepkörrel lépnek be.",
	"{{role}} and above join here as {{local}}.": "{{role}} és felettük itt {{local}} szerepkörrel lépnek be.",
	"{{role}} to {{hi}} join here as {{local}}.": "{{role}} – {{hi}} itt {{local}} szerepkörrel lépnek be.",
	"Saved": "Mentve",
	"Failed to save": "Mentés sikertelen",
	"Context switcher": "Környezetváltó",
	"My profile": "Saját profil",
	"expired": "lejárt",
	"{{hours}}h {{minutes}}m": "{{hours}}ó {{minutes}}p",
	"{{minutes}}m": "{{minutes}}p",
	"This community's identity has expired": "A közösség azonosítója lejárt",
	"It was not activated in time and will not accept new content. Members can still view what's already here.": "Nem lett aktiválva időben, így új tartalmakat már nem fogad. A tagok továbbra is megtekinthetik a meglévő tartalmat.",
	"This community's identity will be deleted in {{remaining}} if not activated": "A közösség azonosítója {{remaining}} múlva törlődik, ha nem kerül aktiválásra",
	"This community's identity has not been activated yet": "A közösség azonosítója még nem lett aktiválva",
	"An activation email was sent. Until it's confirmed, content posted here may be lost. The deadline doesn't change if you resend.": "Aktiváló e-mailt küldtünk. A megerősítésig az itt közzétett tartalom elveszhet. A határidő nem változik újraküldéskor.",
	"Email sent": "E-mail elküldve",
	"Resend activation": "Aktiválás újraküldése",
	"An unexpected error occurred. You can try reloading the page or going back.": "Váratlan hiba történt. Próbáld újratölteni az oldalt, vagy menj vissza.",
	"Error details": "Hibaadatok",
	"Reload page": "Oldal újratöltése",
	"Created {{date}}": "Létrehozva: {{date}}",
	"View details": "Részletek megtekintése",
	"Delete identity": "Azonosító törlése",
	"Must be 3-32 characters": "3-32 karakter hosszúnak kell lennie",
	"Letters, numbers, and hyphens only. Cannot start or end with hyphen.": "Csak betűk, számok és kötőjelek. Nem kezdődhet és nem végződhet kötőjellel.",
	"Invalid email address": "Érvénytelen e-mail cím",
	"Failed to create identity": "Azonosító létrehozása sikertelen",
	"Create New Identity": "Új azonosító létrehozása",
	"Identity Name": "Azonosító neve",
	"Letters, numbers, and hyphens. 3-32 characters.": "Betűk, számok és kötőjelek. 3-32 karakter.",
	"Owner Email": "Tulajdonos e-mail címe",
	"Send activation email": "Aktiváló e-mail küldése",
	"User will receive an activation link via email.": "A felhasználó aktiváló linket kap e-mailben.",
	"Identity will be created as active immediately.": "Az azonosító azonnal aktívként lesz létrehozva.",
	"Create API key": "API kulcs létrehozása",
	"Generate an API key for programmatic access (e.g., dynamic DNS updates).": "Generálj API kulcsot programozott hozzáféréshez (pl. dinamikus DNS frissítések).",
	"Key Name (optional)": "Kulcs neve (opcionális)",
	"e.g., Home server DynDNS": "pl. otthoni szerver DynDNS",
	"Create Identity": "Azonosító létrehozása",
	"Identity Created Successfully": "Azonosító sikeresen létrehozva",
	"{{identity}} has been created. An activation email has been sent to {{email}}.": "A(z) {{identity}} létrejött. Aktiváló e-mailt küldtünk a következő címre: {{email}}.",
	"Save this API key now!": "Mentsd el most ezt az API kulcsot!",
	"This key will only be shown once. Store it securely.": "Ezt a kulcsot csak egyszer mutatjuk meg. Tárold biztonságosan.",
	"API Key": "API kulcs",
	"Example: Update IP Address": "Példa: IP-cím frissítése",
	"Copy command": "Parancs másolása",
	"Updates the IP address automatically from the client IP.": "Automatikusan frissíti az IP-címet a kliens IP-je alapján.",
	"I've saved the key": "Elmentettem a kulcsot",
	"Identity Information": "Azonosító információ",
	"Not set": "Nincs beállítva",
	"Address": "Cím",
	"Not configured": "Nincs konfigurálva",
	"DNS TTL": "DNS TTL",
	"Dynamic DNS (60s TTL)": "Dinamikus DNS (60s TTL)",
	"Standard (1 hour TTL)": "Szabványos (1 óra TTL)",
	"Enable Dynamic DNS for identities with changing IP addresses.": "Engedélyezd a Dinamikus DNS-t változó IP-című azonosítókhoz.",
	"Create Key": "Kulcs létrehozása",
	"e.g., Home server": "pl. otthoni szerver",
	"No API keys. Create one for programmatic access.": "Nincsenek API kulcsok. Hozz létre egyet a programozott hozzáféréshez.",
	"Revoke this API key? This cannot be undone.": "Visszavonod ezt az API kulcsot? Ez nem vonható vissza.",
	"Revoking...": "Visszavonás...",
	"Revoke": "Visszavonás",
	"Last used {{date}}": "Utoljára használva: {{date}}",
	"Revoke key": "Kulcs visszavonása",
	"Delete Identity": "Azonosító törlése",
	"API Key Created": "API kulcs létrehozva",
	"Delete {{identity}}?": "Törlöd a(z) {{identity}} azonosítót?",
	"This will permanently delete this identity and all associated API keys. Users will lose access. This action cannot be undone.": "Ez véglegesen törli az azonosítót és az összes hozzá tartozó API kulcsot. A felhasználók hozzáférést vesztenek. A művelet nem vonható vissza.",
	"You need leader permissions to manage identities.": "Vezetői jogosultság szükséges az azonosítók kezeléséhez.",
	"Search by name or email...": "Keresés név vagy e-mail alapján...",
	"Search identities": "Azonosítók keresése",
	"Clear search": "Keresés törlése",
	"Suspended": "Felfüggesztve",
	"Loading identities...": "Azonosítók betöltése...",
	"No identities matching \"{{query}}\"": "Nincs a(z) \"{{query}}\" kifejezésnek megfelelő azonosító",
	"No {{status}} identities": "Nincs {{status}} azonosító",
	"No identities yet": "Még nincsenek azonosítók",
	"Create your first identity to get started.": "Hozd létre az első azonosítódat a kezdéshez.",
	"Circle": "Kör",
	"Free": "Ingyenes",
	"More menu items": "További menüpontok",
	"Session expired. Please sign in again.": "A munkamenet lejárt. Kérlek jelentkezz be újra.",
	"Main navigation": "Fő navigáció",
	"User menu": "Felhasználói menü",
	"Menu": "Menü",
	"Sign in": "Bejelentkezés",
	"Sign in to {{idTag}}": "Bejelentkezés ide: {{idTag}}",
	"Preparing QR code...": "QR-kód előkészítése...",
	"Language": "Nyelv",
	"Mobile navigation": "Mobil navigáció",
	"Unsynced work at risk": "Nem szinkronizált munka veszélyben",
	"Your encryption key is missing, so the data stored on this device can no longer be read. This can happen if your browser cookie storage was temporarily inaccessible (e.g. when Chrome cannot access its encrypted database).": "A titkosítási kulcsod hiányzik, így az eszközön tárolt adatok már nem olvashatók. Ez akkor fordulhat elő, ha a böngésző süti tárolója átmenetileg elérhetetlen volt (pl. ha a Chrome nem fér hozzá a titkosított adatbázisához).",
	"These documents have local changes that were never sent to the server:": "Az alábbi dokumentumokban vannak helyi módosítások, amelyek soha nem jutottak el a szerverre:",
	"Reloading often restores the key. Try that before discarding anything.": "Az újratöltés gyakran visszaállítja a kulcsot. Próbáld ezt, mielőtt bármit eldobsz.",
	"This will discard those unsynced changes along with all other locally stored data, and require you to log in again. Click again to confirm.": "Ez eldobja ezeket a nem szinkronizált módosításokat az összes többi helyileg tárolt adattal együtt, és újra be kell jelentkezned. Kattints újra a megerősítéshez.",
	"Confirm Discard": "Eldobás megerősítése",
	"Discard {{count}} unsynced documents_one": "{{count}} nem szinkronizált dokumentum eldobása",
	"Discard {{count}} unsynced documents_other": "{{count}} nem szinkronizált dokumentum eldobása",
	"Skip to main content": "Ugrás a fő tartalomra",
	"Notifications ({{count}} new)_one": "Értesítések ({{count}} új)",
	"Notifications ({{count}} new)_other": "Értesítések ({{count}} új)",
	"Follow people or join communities to see activity here.": "Kövess embereket vagy csatlakozz közösségekhez, hogy itt tevékenységet láss.",
	"Messages": "Üzenetek",
	"New Message": "Új üzenet",
	"Connection Request": "Kapcsolódási kérelem",
	"File Shared": "Megosztott fájl",
	"New Follower": "Új követő",
	"New Comment": "Új megjegyzés",
	"New Reaction": "Új reakció",
	"Mention": "Említés",
	"New Post": "Új bejegyzés",
	"Group Invitation": "Csoport meghívó",
	"Community Invitation": "Közösség meghívó",
	"Notification": "Értesítés",
	"Someone": "Valaki",
	"New message from {{name}}": "Új üzenet tőle: {{name}}",
	"{{name}} wants to connect": "{{name}} kapcsolódni szeretne",
	"{{name}} shared a file with you": "{{name}} megosztott veled egy fájlt",
	"{{name}} started following you": "{{name}} követni kezdett",
	"{{name}} commented on your post": "{{name}} megjegyzést írt a bejegyzésedhez",
	"{{name}} reacted to your post": "{{name}} reagált a bejegyzésedre",
	"{{name}} mentioned you": "{{name}} megemlített",
	"New post from {{name}}": "Új bejegyzés tőle: {{name}}",
	"{{name}} invited you to join a group": "{{name}} meghívott egy csoportba",
	"{{name}} invited you to create a community": "{{name}} meghívott egy közösség létrehozására",
	"New notification from {{name}}": "Új értesítés tőle: {{name}}",
	"Failed to join community. You can try again later in Settings.": "A közösséghez csatlakozás sikertelen. Később újra megpróbálhatod a Beállításokban.",
	"Step {{current}} of {{total}}": "{{current}} / {{total}} lépés",
	"Failed to load identity status. Try refreshing the page.": "Az azonosító állapotának betöltése sikertelen. Próbáld újratölteni az oldalt.",
	"Failed to resend activation email. Please try again.": "Az aktiváló e-mail újraküldése sikertelen. Kérlek próbáld újra.",
	"Verify your identity": "Azonosítód igazolása",
	"Loading identity status...": "Azonosító állapotának betöltése...",
	"We sent a separate activation email from your identity provider {{provider}}. Click the link in that email to activate your federated identity — until you do, this account is held in a pending state and will be deleted automatically.": "Külön aktiváló e-mailt küldtünk az azonosítószolgáltatódtól ({{provider}}). Kattints a benne lévő linkre a föderált azonosítód aktiválásához — addig a fiók függő állapotban van, és automatikusan törlődik.",
	"We sent a separate activation email from your identity provider. Click the link in that email to activate your federated identity — until you do, this account is held in a pending state and will be deleted automatically.": "Külön aktiváló e-mailt küldtünk az azonosítószolgáltatódtól. Kattints a benne lévő linkre a föderált azonosítód aktiválásához — addig a fiók függő állapotban van, és automatikusan törlődik.",
	"Sent to: {{email}}": "Címzett: {{email}}",
	"Your identity will be deleted in {{remaining}}": "Az azonosítód {{remaining}} múlva törlődik",
	"The deadline doesn't change if you resend — it was set when you registered. If it expires, you'll need to register again.": "A határidő nem változik újraküldéskor — a regisztrációkor lett megállapítva. Ha lejár, újra kell regisztrálnod.",
	"Your identity has expired": "Az azonosítód lejárt",
	"Please register again to create a new identity.": "Kérlek regisztrálj újra új azonosító létrehozásához.",
	"Email sent — check your inbox": "E-mail elküldve — nézd meg a postaládád",
	"Resend activation email": "Aktiváló e-mail újraküldése",
	"Waiting for activation...": "Aktiválásra várva...",
	"Add Section": "Szakasz hozzáadása",
	"2-Column Layout": "2 oszlopos elrendezés",
	"Side-by-side sections": "Egymás melletti szakaszok",
	"No information available": "Nem áll rendelkezésre információ",
	"Drag a section here": "Húzz ide egy szakaszt",
	"Discard changes": "Változtatások elvetése",
	"Are you sure you want to discard unsaved changes?": "Biztosan elveted a nem mentett változtatásokat?",
	"Editing About Page": "Tartalom oldal szerkesztése",
	"Delete section": "Szakasz törlése",
	"Are you sure you want to delete \"{{title}}\"?": "Biztosan törlöd a(z) \"{{title}}\" szakaszt?",
	"Rename section": "Szakasz átnevezése",
	"Write community rules and guidelines...": "Közösségi szabályok és útmutatók írása...",
	"Write something...": "Írj valamit...",
	"Website": "Weboldal",
	"School / University": "Iskola / Egyetem",
	"Degree / Field of study": "Végzettség / Szakterület",
	"To": "Eddig",
	"Add entry": "Bejegyzés hozzáadása",
	"URL": "URL",
	"Add link": "Hivatkozás hozzáadása",
	"City": "Város",
	"Country": "Ország",
	"Add a tag...": "Címke hozzáadása...",
	"Role / Position": "Szerep / Pozíció",
	"Failed to revoke invitation": "Meghívó visszavonása sikertelen",
	"(unknown)": "(ismeretlen)",
	"Failed to approve request": "Kérelem jóváhagyása sikertelen",
	"Failed to reject request": "Kérelem elutasítása sikertelen",
	"View profile": "Profil megtekintése",
	"Pin {{name}} to context bar": "{{name}} rögzítése a környezetsávra",
	"Currently viewing {{name}} (not pinned)": "Most: {{name}} (nincs rögzítve)",
	"{{count}} invitations sent_one": "{{count}} meghívó elküldve",
	"{{count}} invitations sent_other": "{{count}} meghívó elküldve",
	"Remove member": "Tag eltávolítása",
	"Are you sure you want to remove {{name}} from this community?": "Biztosan eltávolítod {{name}} tagot a közösségből?",
	"Role updated": "Szerep frissítve",
	"Failed to update role": "Szerep frissítése sikertelen",
	"Member removed": "Tag eltávolítva",
	"Failed to remove member": "Tag eltávolítása sikertelen",
	"You need leader permissions to access community settings.": "Vezetői jogosultság szükséges a közösségi beállítások eléréséhez.",
	"Connection Mode": "Kapcsolódási mód",
	"Manual approval": "Manuális jóváhagyás",
	"Auto-accept": "Automatikus elfogadás",
	"Controls how connection requests to this community are handled.": "Szabályozza, hogy a közösséghez beérkező kapcsolódási kérelmeket hogyan kezeljük.",
	"Allow followers": "Követők engedélyezése",
	"Allow users to follow this community without becoming members.": "Engedélyezi, hogy a felhasználók a közösséget tagság nélkül kövessék.",
	"Federation": "Föderáció",
	"Auto-approve incoming actions": "Beérkező események automatikus jóváhagyása",
	"When enabled, posts and messages from trusted sources are automatically approved.": "Ha engedélyezve van, a megbízható forrásokból érkező bejegyzések és üzenetek automatikusan jóváhagyásra kerülnek.",
	"Show partner communities publicly": "Partnerközösségek nyilvános megjelenítése",
	"Members always see the partner list.": "A tagok mindig látják a partnerlistát.",
	"Loading settings...": "Beállítások betöltése...",
	"Visibility cap": "Láthatósági korlát",
	"Public (no limit)": "Nyilvános (nincs korlát)",
	"Limits the maximum visibility of posts in this community. Members cannot publish posts more public than this setting.": "Korlátozza a bejegyzések maximális láthatóságát ebben a közösségben. A tagok nem tehetnek közzé ennél a beállításnál nyilvánosabb bejegyzéseket.",
	"Your domain already has a website. Use the App address field above to set a subdomain for Cloudillo (e.g., cloudillo.{{idTag}}).": "A doménod már rendelkezik weboldallal. A fenti App cím mezővel állíts be aldomaint a Cloudillóhoz (pl. cloudillo.{{idTag}}).",
	"This app address also points to another website. Try a different subdomain in the App address field (e.g., cloudillo.{{idTag}}).": "Ez az app cím egy másik weboldalra is mutat. Próbálj meg másik aldomaint az App cím mezőben (pl. cloudillo.{{idTag}}).",
	"Copy to clipboard": "Másolás vágólapra",
	"Changes can take up to an hour to work.": "A változtatások érvénybelépése akár egy órát is igénybe vehet.",
	"Profile Tabs": "Profil fülek",
	"Default tab": "Alapértelmezett fül",
	"Close search": "Keresés bezárása",
	"Failed to save menu configuration.": "A menü beállításának mentése sikertelen.",
	"Failed to reset menu configuration.": "A menü beállításának visszaállítása sikertelen.",
	"Drag items here": "Húzz ide elemeket",
	"App menu": "Alkalmazásmenü",
	"Reset to defaults": "Visszaállítás alapértelmezettre",
	"Reset": "Visszaállítás",
	"Main menu": "Főmenü",
	"Up to {{count}} items shown in the navigation bar_one": "Legfeljebb {{count}} elem jelenik meg a navigációs sávban",
	"Up to {{count}} items shown in the navigation bar_other": "Legfeljebb {{count}} elem jelenik meg a navigációs sávban",
	"Extra menu": "Extra menü",
	"Shown in the \"More\" overflow menu": "A \"Több\" túlcsorduló menüben látható",
	"Available": "Elérhető",
	"Not shown in menu": "Nem jelenik meg a menüben",
	"Reset App Cache": "Alkalmazás-gyorsítótár visszaállítása",
	"This will clear cached files and reload the page. Your data and login will not be affected. Continue?": "Ez törli a gyorsítótárazott fájlokat és újratölti az oldalt. Az adataid és a bejelentkezésed nem érintett. Folytatod?",
	"Troubleshooting": "Hibaelhárítás",
	"Clear cached files and reload. Use if the app behaves unexpectedly.": "Töröld a gyorsítótárazott fájlokat és töltsd újra. Akkor használd, ha az alkalmazás váratlanul viselkedik.",
	"Rebuild Search Index": "Keresési index újraépítése",
	"This re-scans all files, documents, profiles and posts to rebuild the search index. It runs in the background and may take several minutes. Continue?": "Ez újraolvassa az összes fájlt, dokumentumot, profilt és bejegyzést a keresési index újraépítéséhez. A háttérben fut, és több percig is eltarthat. Folytatod?",
	"Rebuilding search index": "Keresési index újraépítése folyamatban",
	"This runs in the background. You will be notified when it finishes.": "A művelet a háttérben fut. Értesítünk, ha elkészült.",
	"Search index rebuilt": "A keresési index újraépült",
	"{{count}} items re-indexed_one": "{{count}} elem újraindexelve",
	"{{count}} items re-indexed_other": "{{count}} elem újraindexelve",
	"Search index rebuild failed": "A keresési index újraépítése sikertelen",
	"It will be retried automatically in the background.": "A rendszer a háttérben automatikusan újrapróbálja.",
	"The rebuild could not be completed.": "Az újraépítést nem sikerült befejezni.",
	"Re-scan your files and posts. Use if search results are missing or stale.": "Fájlok és bejegyzések újraolvasása. Használd, ha a keresési találatok hiányosak vagy elavultak.",
	"Rebuild": "Újraépítés",
	"Optimize Database": "Adatbázis optimalizálása",
	"This merges search index segments and reclaims unused disk space across the whole server. It runs in the background and may briefly slow down writes. Continue?": "Ez összevonja a keresési index szegmenseit és felszabadítja a nem használt lemezterületet a teljes kiszolgálón. A háttérben fut, és rövid ideig lassíthatja az írásokat. Folytatod?",
	"Compact the search index and reclaim unused disk space. Affects the whole server.": "Tömöríti a keresési indexet és felszabadítja a nem használt lemezterületet. A teljes kiszolgálót érinti.",
	"Optimizing database": "Adatbázis optimalizálása folyamatban",
	"Optimize": "Optimalizálás",
	"Database optimized": "Az adatbázis optimalizálva",
	"The database was rewritten and is now {{size}}.": "Az adatbázis újraíródott, mérete most {{size}}.",
	"Search index compacted; the file had too little free space to be worth rewriting.": "A keresési index tömörítve; a fájlban túl kevés szabad hely volt ahhoz, hogy megérje újraírni.",
	"Database optimization failed": "Az adatbázis optimalizálása sikertelen",
	"The optimization could not be completed.": "Az optimalizálást nem sikerült befejezni.",
	"Version": "Verzió",
	"Create API Key": "API kulcs létrehozása",
	"Save this key now!": "Mentsd el most ezt a kulcsot!",
	"API key": "API kulcs",
	"Scopes": "Hatókörök",
	"No API keys yet.": "Még nincsenek API kulcsok.",
	"Full access": "Teljes hozzáférés",
	"SMTP Host is required": "SMTP hoszt megadása kötelező",
	"Port must be 1-65535": "A portnak 1-65535 között kell lennie",
	"Invalid email format": "Érvénytelen e-mail formátum",
	"Failed to send test email": "Teszt e-mail küldése sikertelen",
	"defaults to username": "alapértelmezett: felhasználónév",
	"You have unsaved changes": "Vannak nem mentett változtatásaid",
	"Save settings": "Beállítások mentése",
	"Test Email": "Teszt e-mail",
	"Send a test email to verify your SMTP configuration.": "Küldj teszt e-mailt az SMTP konfiguráció ellenőrzéséhez.",
	"recipient@example.com": "cimzett@pelda.com",
	"Sending...": "Küldés...",
	"Send test email": "Teszt e-mail küldése",
	"Test email sent successfully!": "Teszt e-mail sikeresen elküldve!",
	"Connection mode": "Kapcsolódási mód",
	"Ignore (reject all)": "Mellőzés (mind elutasítva)",
	"Controls how connection requests to your profile are handled.": "Szabályozza, hogy a profilodhoz beérkező kapcsolódási kérelmeket hogyan kezeljük.",
	"Anyone can connect with you immediately.": "Bárki azonnal kapcsolódhat veled.",
	"Connection requests are automatically rejected.": "A kapcsolódási kérelmek automatikusan elutasításra kerülnek.",
	"You will be asked to approve each connection request.": "Minden kapcsolódási kérelmet jóvá kell hagynod.",
	"When enabled, posts and messages from trusted sources are automatically approved without manual review.": "Ha engedélyezve van, a megbízható forrásokból érkező bejegyzések és üzenetek automatikusan jóváhagyásra kerülnek manuális ellenőrzés nélkül.",
	"Maximum streaming file size (MB)": "Maximális streaming fájl méret (MB)",
	"Maximum size for streaming uploads (video/audio)": "Streaming feltöltések (videó/hang) maximális mérete",
	"Default Tenant Limits": "Alapértelmezett bérlői korlátok",
	"Defaults applied to every tenant unless overridden on Site admin → Tenants → (select a tenant).": "Minden bérlőre érvényes alapértelmezett értékek, hacsak nincs felülírva a Webhely adminisztráció → Bérlők → (válassz egy bérlőt) menüben.",
	"Default storage quota (GB)": "Alapértelmezett tárhelykvóta (GB)",
	"Default storage quota for every tenant.": "Alapértelmezett tárhelykvóta minden bérlő számára.",
	"Variant sync timeout (seconds)": "Változat-szinkronizációs időtúllépés (másodperc)",
	"Per-attachment variant sync timeout (seconds; default applied to all tenants unless overridden).": "Mellékletenkénti változat-szinkronizációs időtúllépés (másodperc; minden bérlőre érvényes alapérték, hacsak nincs felülírva).",
	"Federated attachments": "Föderált mellékletek",
	"Use shared blob store for public attachments": "Megosztott blob-tár használata nyilvános mellékletekhez",
	"Use the shared TnId(0) blob store for Public/Verified federated attachments (deduplicates across tenants).": "A megosztott TnId(0) blob-tár használata nyilvános/ellenőrzött föderált mellékletekhez (deduplikál a bérlők között).",
	"Garbage collection": "Szemétgyűjtés",
	"GC schedule (cron)": "GC ütemezés (cron)",
	"Cron expression for the GC schedule (5-field: 'minute hour day month weekday').": "Cron kifejezés a GC ütemezéshez (5 mező: 'perc óra nap hónap hét napja').",
	"Safety window (seconds)": "Biztonsági ablak (másodperc)",
	"Minimum age (seconds) before an unreferenced managed file row or orphan blob becomes eligible for GC — protects against sync-in-progress and wiring-up races.": "Minimális életkor (másodpercben), mielőtt egy hivatkozás nélküli managed fájl rekord vagy árva blob GC-re jogosulttá válik — védelem a folyamatban lévő szinkronizálás és bekötés-közbeni versenyek ellen.",
	"Tenant not found.": "A bérlő nem található.",
	"Failed to load tenant. Please try again.": "A bérlő betöltése sikertelen. Próbáld újra.",
	"Failed to load setting. Please try again.": "A beállítás betöltése sikertelen. Próbáld újra.",
	"Failed to save setting. Please try again.": "A beállítás mentése sikertelen. Próbáld újra.",
	"Default for all tenants: {{n}} GB.": "Minden bérlő alapértéke: {{n}} GB.",
	"No override set — inheriting the default.": "Nincs felülírás — az alapérték öröklődik.",
	"Set a value here to override for this tenant.": "Adj meg egy értéket itt, hogy felülírd ennél a bérlőnél.",
	"Reset to default": "Visszaállítás alapértékre",
	"Enter a value between 1 and 100000.": "Adj meg egy értéket 1 és 100000 között.",
	"Authentication failed: re-enter SMTP username and password.": "Hitelesítés sikertelen: add meg újra az SMTP felhasználónevet és jelszót.",
	"Cannot reach SMTP server: verify host, port, and firewall rules.": "Az SMTP szerver nem érhető el: ellenőrizd a hosztot, portot és tűzfal szabályokat.",
	"TLS handshake failed: check the TLS mode and port (try 'starttls' on 587 or 'tls' on 465).": "TLS kézfogás sikertelen: ellenőrizd a TLS módot és portot (próbáld a 'starttls'-t 587-en vagy a 'tls'-t 465-ön).",
	"Transient SMTP failure: the server returned a temporary error — retrying may succeed.": "Átmeneti SMTP hiba: a szerver ideiglenes hibával válaszolt — újrapróbálkozásra sikerülhet.",
	"Permanent SMTP failure: the server rejected the message; check from-address, sending policy, and recipient.": "Tartós SMTP hiba: a szerver elutasította az üzenetet; ellenőrizd a feladó címét, a küldési szabályokat és a címzettet.",
	"SMTP request failed. See raw error below for details.": "Az SMTP kérés sikertelen. A részletekért lásd a nyers hibaüzenetet alább.",
	"SMTP code": "SMTP kód",
	"Server response": "Szerver válasz",
	"Raw error": "Nyers hibaüzenet",
	"Processing video": "Videó feldolgozása",
	"Processing video…": "Videó feldolgozása…",
	"Play video": "Videó lejátszása",
	"Scheduled": "Ütemezett",
	"Processing": "Feldolgozás alatt",
	"Source": "Forrás",
	"You haven't posted anything yet.": "Még nem tettél közzé semmit.",
	"No direct messages yet.": "Még nincsenek közvetlen üzenetek.",
	"No posts from people you follow yet — try following someone or switch to All.": "Még nincsenek bejegyzések az általad követettektől — kövess valakit, vagy válts az Összesre.",
	"No posts in your communities yet.": "Még nincsenek bejegyzések a közösségeidben.",
	"No public posts to show.": "Nincs megjeleníthető nyilvános bejegyzés.",
	"Wait for upload to finish": "Várj a feltöltés befejeztéig",
	"1 person": "1 személy",
	"{{n}} people": "{{n}} személy",
	"1 link": "1 hivatkozás",
	"{{n}} links": "{{n}} hivatkozás",
	"This file is private": "Ez a fájl privát",
	"Share file": "Fájl megosztása",
	"Filter": "Szűrő",
	"Go to parent folder": "Ugrás a szülőmappába",
	"invited you to": "meghívott a következőhöz:",
	"Dismiss": "Elvetés",
	"Filename": "Fájlnév",
	"Invited you to join this group": "Meghívott ehhez a csoporthoz",
	"Invited you to join this community": "Meghívott ehhez a közösséghez",
	"Yesterday": "Tegnap",
	"Earlier": "Korábban",
	"No {{category}} notifications": "Nincs {{category}} értesítés",
	"Show all": "Összes megjelenítése",
	"Unknown": "Ismeretlen",
	"Tenant actions": "Bérlő műveletei",
	"{{idTag}} has been removed.": "{{idTag}} eltávolítva.",
	"Mine": "Sajátjaim",
	"Communities": "Közösségek",
	"Date taken": "Felvétel dátuma",
	"Sort ascending": "Növekvő sorrend",
	"Sort descending": "Csökkenő sorrend",
	"Follower+": "Követő+",
	"Supporter+": "Támogató+",
	"Contributor+": "Közreműködő+",
	"Moderator+": "Moderátor+",
	"Leader only": "Csak vezető",
	"Rich text description": "Formázott szöveges leírás",
	"Contact": "Elérhetőség",
	"Email, phone, website": "Email, telefon, weboldal",
	"City, country, address": "Város, ország, cím",
	"Links": "Hivatkozások",
	"External links with icons": "Külső hivatkozások ikonokkal",
	"Experience": "Tapasztalat",
	"Work experience": "Munkatapasztalat",
	"Education": "Tanulmányok",
	"Schools and degrees": "Iskolák és végzettségek",
	"Skills & Interests": "Készségek és érdeklődési körök",
	"Tags and keywords": "Címkék és kulcsszavak",
	"Community Rules": "Közösségi szabályok",
	"Guidelines and rules": "Irányelvek és szabályok",
	"Custom Section": "Egyéni szakasz",
	"Free-form rich text block": "Szabad formátumú szövegblokk",
	"Section": "Szakasz",
	"Follower": "Követő",
	"Supporter": "Támogató",
	"Contributor": "Közreműködő",
	"Leader": "Vezető",
	"Gallery": "Galéria",
	"App Package Publish": "Alkalmazáscsomag közzététele",
	"Allows publishing app packages to the repository.": "Lehetővé teszi alkalmazáscsomagok közzétételét a tárolóban.",
	"Passkey": "Jelkulcs",
	"Device": "Eszköz",
	"Devices": "Eszközök",
	"Thumbnail (tn)": "Bélyegkép (tn)",
	"Standard (sd)": "Normál (sd)",
	"Medium (md)": "Közepes (md)",
	"High (hd)": "Magas (hd)",
	"Extra (xd)": "Extra (xd)",
	"Share via QR code": "Megosztás QR-kóddal",
	"Scan with a phone camera, or copy the link below.": "Olvasd be telefon kamerájával, vagy másold a lenti linket.",
	"Shareable link": "Megosztható link",
	"Copied": "Másolva",
	"Copy": "Másolás",
	"Share…": "Megosztás…",
	"Failed to encode image. Try a smaller source.": "A kép kódolása sikertelen. Próbálj kisebb forrást.",
	"Invitation link": "Meghívó link",
	"More matches exist outside this folder.": "További találatok vannak ezen a mappán kívül.",
	"Search all files": "Keresés mindenhol",
	"Searching all files": "Keresés az összes fájlban…",
	"In folder:": "Mappában:",
	"Pick up": "Felvesz",
	"Add shortcut here": "Parancsikon ide",
	"Place here…": "Elhelyez itt…",
	"Restore here": "Visszaállít ide",
	"Drop": "Elejt",
	"Empty hand": "Kéz kiürítése",
	"Forget": "Elfelejt",
	"Hand set down — click to pick up again.": "Kéz letéve — kattints az újrafelvételhez.",
	"{{ok}} of {{total}} files succeeded. {{failed}} failed: {{reason}}.": "{{ok}}/{{total}} fájl sikerült. {{failed}} sikertelen: {{reason}}.",
	"You don't have permission to share this file": "Nincs jogosultságod megosztani ezt a fájlt",
	"This access level is not allowed for this file type": "Ez a hozzáférési szint nem engedélyezett ehhez a fájltípushoz",
	"Source file no longer exists": "A forrásfájl már nem létezik",
	"Source server is unreachable — please retry": "A forrásszerver nem érhető el — próbáld újra",
	"Already placed in this context (in folder {{folder}})": "Már elhelyezve ebben a kontextusban (a következő mappában: {{folder}})",
	"Already placed in this context": "Már elhelyezve ebben a kontextusban",
	"Only {{n}} of {{m}} items can be {{verb}} here. Drop the others or empty your hand.": "Csak {{n}}/{{m}} elem {{verb}} ide. Ejtsd el a többit vagy ürítsd ki a kezed.",
	"Hand contains a different item type. Empty the hand first.": "A kéz más típusú elemet tartalmaz. Előbb üríts ki.",
	"access denied": "hozzáférés megtagadva",
	"added as shortcuts": "parancsikonként hozzáadható",
	"placed": "elhelyezhető",
	"moved": "áthelyezhető",
	"restored": "visszaállítható",
	"Permission": "Jogosultság",
	"Place \"{{name}}\" in \"{{folder}}\"": "\"{{name}}\" elhelyezése itt: \"{{folder}}\"",
	"the current folder": "az aktuális mappa",
	"Choose what recipients can do:": "Válaszd ki, mit tehetnek a címzettek:",
	"Recipients can view the files.": "A címzettek megtekinthetik a fájlokat.",
	"Recipients can view and add comments.": "A címzettek megtekinthetik és hozzászólhatnak.",
	"Recipients can edit the content.": "A címzettek szerkeszthetik a tartalmat.",
	"last used": "legutóbb használt",
	"Place": "Elhelyezés",
	"Place files": "Fájlok elhelyezése",
	"Esc to cancel · ⏎ to place": "Esc a megszakításhoz · ⏎ az elhelyezéshez",
	"No longer shared with you by {{idTag}}.": "{{idTag}} már nem osztja meg veled.",
	"The owner deleted this file.": "A tulajdonos törölte ezt a fájlt.",
	"{{host}} couldn't be reached. We'll keep trying.": "{{host}} nem elérhető. Tovább próbálkozunk.",
	"Move \"{{name}}\" to trash?": "\"{{name}}\" áthelyezése a kukába?",
	"This file is currently used by:\n- {{links}} share link(s)\n- {{embeds}} embed(s)\n\nTrashing it will break those references.": "Ezt a fájlt jelenleg használja:\n- {{links}} megosztási hivatkozás\n- {{embeds}} beágyazás\n\nA kukába helyezéssel ezek megszakadnak.",
	"Open in read-only mode?": "Megnyitás csak olvasható módban?",
	"Your access to this file changed from {{requested}} to {{granted}}. Open in read-only mode?": "A fájlhoz tartozó hozzáférésed {{requested}}-ról {{granted}}-ra változott. Megnyitod csak olvasható módban?",
	"This file is no longer shared with you.": "Ezt a fájlt már nem osztják meg veled.",
	"The owner's server couldn't be reached.": "A tulajdonos szervere nem elérhető.",
	"This file is no longer available.": "Ez a fájl már nem elérhető.",
	"Unable to verify file access. Please try again.": "A hozzáférés ellenőrzése sikertelen. Próbáld újra.",
	"Access denied.": "Hozzáférés megtagadva.",
	"Muted": "Némítva",
	"Blocked": "Blokkolva",
	"Unsuspend": "Felfüggesztés feloldása",
	"Unmute": "Némítás feloldása",
	"Restore to Active": "Visszaállítás aktívra",
	"Profile restored": "Profil visszaállítva",
	"Failed to restore profile": "A profil visszaállítása sikertelen",
	"Relationship": "Kapcsolat",
	"All statuses": "Összes állapot",
	"Like": "Tetszik",
	"Love": "Imádom",
	"Haha": "Haha",
	"Wow": "Hűha",
	"Sad": "Szomorú",
	"Angry": "Mérges",
	"Liked": "Tetszett",
	"Loved": "Imádtam",
	"Remove reaction": "Reakció eltávolítása",
	"React": "Reagálás",
	"Change reaction": "Reakció megváltoztatása",
	"Visit profile": "Profil megnyitása",
	"Show in Home feed": "Megjelenítés a Kezdőlapon",
	"Identity tag copied": "Azonosító vágólapra másolva",
	"Editor": "Szerkesztő",
	"Viewer": "Olvasó",
	"Commenter": "Hozzászóló",
	"Manage sharing": "Megosztás kezelése",
	"People with access": "Hozzáféréssel rendelkezők",
	"Anyone with the link": "Bárki, akinek megvan a link",
	"No share links yet": "Még nincsenek megosztási linkek",
	"No one else has access yet": "Másnak még nincs hozzáférése",
	"you": "te",
	"guest": "vendég",
	"Loading…": "Betöltés…",
	"Comments are on {{idTag}}. Authenticate to read them?": "A hozzászólások a(z) {{idTag}} szerveren vannak. Hitelesítsük a megtekintéshez?",
	"Always trust": "Mindig megbízom",
	"Just now": "Most az egyszer",
	"View community {{name}}": "{{name}} közösség megtekintése",
	"View profile {{name}}": "{{name}} profil megtekintése",
	"Remove access": "Hozzáférés visszavonása",
	"Picked up {{count}} files_one": "Felvettél {{count}} fájlt",
	"Picked up {{count}} files_other": "Felvettél {{count}} fájlt",
	"Pick up {{count}} files_one": "{{count}} fájl felvétele",
	"Pick up {{count}} files_other": "{{count}} fájl felvétele",
	"Used in {{count}} documents_one": "{{count}} dokumentumban használva",
	"Used in {{count}} documents_other": "{{count}} dokumentumban használva",
	"Holding {{count}} files. Switch to Browse to place, move or add shortcuts._one": "{{count}} fájl a kezedben. Válts Böngészés módra az elhelyezéshez, áthelyezéshez vagy parancsikon hozzáadásához.",
	"Holding {{count}} files. Switch to Browse to place, move or add shortcuts._other": "{{count}} fájl a kezedben. Válts Böngészés módra az elhelyezéshez, áthelyezéshez vagy parancsikon hozzáadásához.",
	"Place {{count}} files in \"{{folder}}\"_one": "{{count}} fájl elhelyezése itt: \"{{folder}}\"",
	"Place {{count}} files in \"{{folder}}\"_other": "{{count}} fájl elhelyezése itt: \"{{folder}}\"",
	"Hand: {{count}} files_one": "Kéznél: {{count}} fájl",
	"Hand: {{count}} files_other": "Kéznél: {{count}} fájl",
	"{{count}} applicable_one": "{{count}} alkalmazható",
	"{{count}} applicable_other": "{{count}} alkalmazható",
	"{{count}} files_one": "{{count}} fájl",
	"{{count}} files_other": "{{count}} fájl",
	"+{{count}} more_one": "+{{count}} további",
	"+{{count}} more_other": "+{{count}} további",
	"Permission updated": "Jogosultság frissítve",
	"Failed to update permission": "Nem sikerült frissíteni a jogosultságot",
	"Pick an expiry date, or check Never": "Válassz lejárati dátumot, vagy jelöld be a Soha lehetőséget",
	"Link updated": "Hivatkozás frissítve",
	"Add people…": "Személyek hozzáadása…",
	"Default access for new people": "Alapértelmezett hozzáférés új személyeknek",
	"Remove access for {{name}}?": "Visszavonod {{name}} hozzáférését?",
	"Change access for {{name}}": "{{name}} hozzáférésének módosítása",
	"Change access for link": "Hivatkozás hozzáférésének módosítása",
	"Edit link details": "Hivatkozás adatainak szerkesztése",
	"Unsynced changes will be lost": "A nem szinkronizált változtatások elvesznek",
	"Sign out of {{idTag}}": "Kijelentkezés innen: {{idTag}}",
	"You have {{count}} document(s) with edits that haven't reached the server._one": "{{count}} olyan dokumentumod van, amelynek szerkesztései még nem értek el a szerverre.",
	"You have {{count}} document(s) with edits that haven't reached the server._other": "{{count}} olyan dokumentumod van, amelynek szerkesztései még nem értek el a szerverre.",
	"Signing out now will permanently discard these edits. They cannot be recovered.": "A most végrehajtott kijelentkezés véglegesen eldobja ezeket a szerkesztéseket. Nem állíthatók vissza.",
	"Tip: open the documents in their apps and let them sync, then return here.": "Tipp: nyisd meg a dokumentumokat az alkalmazásaikban, hagyd, hogy szinkronizálódjanak, majd térj vissza ide.",
	"Type {{phrase}} to confirm": "Írd be a megerősítéshez: {{phrase}}",
	"Signing out will permanently remove all locally cached data and the encryption key from this device.": "A kijelentkezés véglegesen eltávolít minden helyben tárolt adatot és a titkosítási kulcsot erről az eszközről.",
	"Your data on the server is unaffected. Signing back in will re-download what you need.": "A szerveren lévő adataidat ez nem érinti. Újbóli bejelentkezéskor a szükséges adatok újra letöltődnek.",
	"Sign out": "Kijelentkezés",
	"Mute": "Némítás",
	"Search for connections to invite": "Keress kapcsolatokat a meghíváshoz",
	"Cancel editing invitation": "Meghívó szerkesztésének megszakítása",
	"Edit invitation": "Meghívó szerkesztése",
	"Max uses": "Max. felhasználás",
	"Unlimited": "Korlátlan",
	"Failed to create invitation": "Nem sikerült létrehozni a meghívót",
	"Invalid expiry": "Érvénytelen lejárat",
	"Invalid max uses": "Érvénytelen max. felhasználás",
	"Enter a max-uses value, or check Unlimited": "Adj meg egy max. felhasználási értéket, vagy jelöld be a Korlátlan lehetőséget",
	"Max uses must be at least 1": "A max. felhasználásnak legalább 1-nek kell lennie",
	"Failed to update invitation": "Nem sikerült frissíteni a meghívót",
	"Added {{count}} shortcuts_one": "{{count}} parancsikon hozzáadva",
	"Added {{count}} shortcuts_other": "{{count}} parancsikon hozzáadva",
	"Placed {{count}} files_one": "{{count}} fájl elhelyezve",
	"Placed {{count}} files_other": "{{count}} fájl elhelyezve",
	"Moved {{count}} files_one": "{{count}} fájl áthelyezve",
	"Moved {{count}} files_other": "{{count}} fájl áthelyezve",
	"Restored {{count}} files_one": "{{count}} fájl visszaállítva",
	"Restored {{count}} files_other": "{{count}} fájl visszaállítva",
	"Profile blocked": "Profil blokkolva",
	"Failed to block profile": "Nem sikerült blokkolni a profilt",
	"Profile muted": "Profil némítva",
	"Failed to mute profile": "Nem sikerült némítani a profilt",
	"{{count}} file in hand_one": "{{count}} fájl a kézben",
	"{{count}} file in hand_other": "{{count}} fájl a kézben",
	"Hand ({{count}})_one": "Kéz ({{count}})",
	"Hand ({{count}})_other": "Kéz ({{count}})",
	"Go to Cloudillo": "Tovább a Cloudillóra",
	"Failed to load folder contents": "Nem sikerült betölteni a mappa tartalmát",
	"Uploaded {{count}} file_one": "{{count}} fájl feltöltve",
	"Uploaded {{count}} file_other": "{{count}} fájl feltöltve",
	"Failed to upload {{names}}": "Nem sikerült feltölteni: {{names}}",
	"Are you sure you want to move \"{{name}}\" to trash?": "Biztosan a kukába helyezed a következőt: „{{name}}”?",
	"Failed to delete \"{{name}}\"": "Nem sikerült törölni: „{{name}}”",
	"Could not load this folder": "Nem sikerült betölteni ezt a mappát",
	"Loading folder…": "Mappa betöltése…",
	"Drop files here or click Upload to add them": "Húzd ide a fájlokat, vagy kattints a Feltöltés gombra",
	"Download {{name}}": "{{name}} letöltése",
	"Delete {{name}}": "{{name}} törlése",
	"Leave blank to use the suggested name": "Hagyd üresen a javasolt név használatához",
	"Some invitations could not be accepted. You can retry in your inbox.": "Néhány meghívót nem sikerült elfogadni. Később újrapróbálhatod a postaládádban.",
	"Someone invited you. Choose what to accept — you can change this later.": "Valaki meghívott. Válaszd ki, mit fogadsz el — ezt később módosíthatod.",
	"Connect with {{name}}": "Kapcsolódás vele: {{name}}",
	"Join {{name}}": "Csatlakozás: {{name}}",
	"Skip": "Kihagyás",
	"Auto-connect on signup": "Automatikus kapcsolódás regisztrációkor",
	"Add to communities": "Hozzáadás közösségekhez",
	"You're not a member of any community yet.": "Még egyetlen közösségnek sem vagy tagja.",
	"More communities": "További közösségek",
	"You can only invite to communities where you are a moderator; others are skipped.": "Csak olyan közösségbe hívhatsz meg, ahol moderátor vagy; a többit a rendszer kihagyja.",
	"Could not set up a passkey. You can add one later in Settings.": "A jelszó nélküli belépést nem sikerült beállítani. Később a Beállításokban hozzáadhatod.",
	"You're all set!": "Minden készen áll!",
	"Set up a passkey": "Jelszó nélküli belépés beállítása",
	"Sign in without a password next time": "Legközelebb jelszó nélkül léphetsz be",
	"Finish": "Befejezés",
	"Get started by joining the Cloudillo community.": "Kezdj neki a Cloudillo közösséghez csatlakozással.",
	"These people want to connect with you.": "Ezek a felhasználók kapcsolódni szeretnének Veled.",
	"You've been invited to join these communities.": "Meghívtak ezekbe a közösségekbe.",
	"Join the Cloudillo community": "Csatlakozz a Cloudillo közösséghez",
	"Cloudillo community": "Cloudillo közösség",
	"Optional note to identify this invitation": "Opcionális megjegyzés a meghívó azonosításához",
	"{{count}} reposts_one": "{{count}} megosztás",
	"{{count}} reposts_other": "{{count}} megosztás",
	"(you)": "(te)",
	"View {{count}} reactions_one": "{{count}} reakció megtekintése",
	"View {{count}} reactions_other": "{{count}} reakció megtekintése",
	"View {{count}} reposts_one": "{{count}} megosztás megtekintése",
	"View {{count}} reposts_other": "{{count}} megosztás megtekintése",
	"Reactions": "Reakciók",
	"Reposts": "Megosztások",
	"Could not load": "Nem sikerült betölteni",
	"No reposts yet": "Még nincsenek megosztások",
	"No reactions yet": "Még nincsenek reakciók",
	"Checking signature…": "Aláírás ellenőrzése…",
	"Signature verified": "Aláírás ellenőrizve",
	"Invalid signature": "Érvénytelen aláírás",
	"No matching key published": "Nincs közzétett megfelelő kulcs",
	"Signature unavailable": "Aláírás nem elérhető",
	"Verify": "Ellenőrzés",
	"Already reposted": "Már megosztva",
	"You have already reposted this to {{name}}.": "Ezt már megosztottad ide: {{name}}.",
	"Image {{n}}": "{{n}}. kép",
	"Document preview": "Dokumentum előnézete",
	"Your connections": "Kapcsolataid",
	"Your communities": "Közösségeid",
	"Too many attempts. Please try again in about {{count}} minute_one": "Túl sok próbálkozás. Kérlek, próbáld újra körülbelül {{count}} perc múlva.",
	"Too many attempts. Please try again in about {{count}} minute_other": "Túl sok próbálkozás. Kérlek, próbáld újra körülbelül {{count}} perc múlva.",
	"Too many attempts. Please try again later.": "Túl sok próbálkozás. Kérlek, próbáld újra később.",
	"Too many requests. Please slow down and try again shortly.": "Túl sok kérés. Kérlek, lassíts, és próbáld újra hamarosan.",
	"Unread": "Olvasatlan",
	"You're all caught up.": "Minden olvasva.",
	"No new posts since your last visit.": "Nincs új bejegyzés az utolsó látogatás óta.",
	"Watching": "Figyelés",
	"Tracking": "Követés",
	"New since your last visit": "Új az utolsó látogatás óta",
	"New content": "Új tartalom",
	"Failed to save profile": "A profil mentése sikertelen",
	"Failed to copy": "A másolás sikertelen",
	"Change cover photo": "Borítókép módosítása",
	"Change profile picture": "Profilkép módosítása",
	"Edit profile": "Profil szerkesztése",
	"Comments ({{count}}, unread)_one": "Hozzászólások ({{count}}, olvasatlan)",
	"Comments ({{count}}, unread)_other": "Hozzászólások ({{count}}, olvasatlan)",
	"Comments ({{count}})_one": "Hozzászólások ({{count}})",
	"Comments ({{count}})_other": "Hozzászólások ({{count}})",
	"This file is still being processed — please try again in a moment.": "A fájl feldolgozása még folyamatban van — kérlek próbáld újra egy pillanat múlva.",
	"Download failed. Please try again.": "A letöltés sikertelen. Kérlek próbáld újra.",
	"Still processing — available shortly": "Feldolgozás alatt — hamarosan elérhető",
	"Failed to load more": "A további elemek betöltése sikertelen",
	"This document": "Ez a dokumentum",
	"Managed files": "Kezelt fájlok",
	"Remove {{name}}?": "Eltávolítod {{name}} felhasználót?",
	"Failed to delete calendar": "A naptár törlése sikertelen",
	"Calendars are not available here": "A naptárak itt nem érhetők el",
	"Failed to load calendars": "A naptárak betöltése sikertelen",
	"You do not have permission to use calendars here.": "Nincs jogosultságod itt naptárakat használni.",
	"Failed to delete address book": "A címjegyzék törlése sikertelen",
	"Contacts are not available here": "A névjegyek itt nem érhetők el",
	"Failed to load address books": "A címjegyzékek betöltése sikertelen",
	"You do not have permission to use contacts here.": "Nincs jogosultságod itt névjegyeket használni.",
	"View sharing": "Megosztás megtekintése",
	"Share link": "Megosztási link",
	"Could not reach the server that holds this file. Please try again.": "A fájlt tároló szerver nem érhető el. Kérlek próbáld újra.",
	"You do not have permission to see who this file is shared with.": "Nincs jogosultságod megnézni, hogy kivel van megosztva ez a fájl.",
	"You can see who this is shared with, but only the owner can change it.": "Látod, hogy kivel van megosztva, de csak a tulajdonos módosíthatja.",
	"You do not have permission to change this file’s visibility.": "Nincs jogosultságod megváltoztatni ennek a fájlnak a láthatóságát.",
	"Failed to change visibility": "A láthatóság módosítása sikertelen",
	"You do not have permission to rename this file.": "Nincs jogosultságod átnevezni ezt a fájlt.",
	"Failed to rename file": "A fájl átnevezése sikertelen",
	"Could not load who this file is shared with. Please try again.": "Nem sikerült betölteni, hogy kivel van megosztva ez a fájl. Kérlek próbáld újra.",
	"New message": "Új üzenet",
	"Search contacts...": "Névjegyek keresése...",
	"New conversation": "Új beszélgetés",
	"New group": "Új csoport",
	"Archived": "Archivált",
	"Unread messages": "Olvasatlan üzenetek",
	"Left": "Kilépett",
	"Search for connections to add": "Hozzáadandó kapcsolatok keresése",
	"Obs": "Megf",
	"Mod": "Mod",
	"A": "A",
	"Inv": "Megh",
	"Image": "Kép",
	"Sent": "Elküldve",
	"Failed to send": "A küldés sikertelen",
	"Send": "Küldés",
	"Scroll to bottom": "Ugrás a végére",
	"New messages": "Új üzenetek",
	"You left this group": "Kiléptél ebből a csoportból",
	"Rejoin": "Újracsatlakozás",
	"This group is invite-only": "Ebbe a csoportba csak meghívóval lehet belépni",
	"Could not keep you signed in on this device. You will need to log in again next time.": "Nem sikerült bejelentkezve tartani ezen az eszközön. Legközelebb újra be kell jelentkezned.",
	"You do not have permission to share this file, so the embed may not be readable by others.": "Nincs jogosultságod megosztani ezt a fájlt, ezért a beágyazást mások esetleg nem tudják megnyitni.",
	"The embed was inserted, but access could not be granted — it may not be readable by others.": "A beágyazás bekerült, de a hozzáférést nem sikerült megadni — mások esetleg nem tudják megnyitni.",
	"You do not have permission to share this file.": "Nincs jogosultságod megosztani ezt a fájlt.",
	"Failed to grant document access": "A dokumentum-hozzáférés megadása sikertelen",
	"Failed to update file visibility": "A fájl láthatóságának frissítése sikertelen",
	"Failed to update push notifications": "A push értesítések frissítése sikertelen",
	"Failed to remove the API key from the server. Please try again.": "Az API kulcs eltávolítása a szerverről sikertelen. Kérlek próbáld újra.",
	"Resolving the share address for this file…": "A fájl megosztási címének meghatározása…",
	"You do not have permission to see this file's share links.": "Nincs jogosultságod megnézni ennek a fájlnak a megosztási linkjeit.",
	"Could not load this file's share links. Please try again.": "Nem sikerült betölteni a fájl megosztási linkjeit. Kérlek próbáld újra.",
	"Expired": "Lejárt",
	"Could not determine the share address for this document.": "Nem sikerült meghatározni a dokumentum megosztási címét.",
	"You cannot create a link with more access than you hold on this file.": "Nem hozhatsz létre olyan linket, amely többet enged, mint amennyi jogosultságod van a fájlon.",
	"The server rejected these link settings.": "A szerver elutasította ezeket a link-beállításokat.",
	"See all {{count}} results_one": "Mind a(z) {{count}} találat megtekintése",
	"See all {{count}} results_other": "Mind a(z) {{count}} találat megtekintése",
	"{{count}} results_one": "{{count}} találat",
	"{{count}} results_other": "{{count}} találat",
	"Page not found": "Az oldal nem található",
	"This address does not match anything in Cloudillo.": "Ez a cím nem felel meg semminek a Cloudillóban.",
	"Go to the feed": "Tovább a hírfolyamra",
	"Open {{idTag}}?": "Megnyitod ezt: {{idTag}}?",
	"Continuing identifies you to that server: Cloudillo signs in on your behalf so it can load the page. Only continue if you trust this address.": "A folytatással azonosítod magad annál a szervernél: a Cloudillo a nevedben jelentkezik be, hogy be tudja tölteni az oldalt. Csak akkor folytasd, ha megbízol ebben a címben.",
	"Actions": "Műveletek",
	"Guest": "Vendég",
	"Open profile": "Profil megnyitása",
	"1 collaborator": "1 együttműködő",
	"{{count}} collaborators_one": "{{count}} együttműködő",
	"{{count}} collaborators_other": "{{count}} együttműködő",
	"Loading document name": "Dokumentum nevének betöltése",
	"Document unavailable": "A dokumentum nem érhető el",
	"Document name": "Dokumentum neve",
	"Could not rename the document": "Nem sikerült átnevezni a dokumentumot",
	"Site": "Webhely",
	"Published from “{{name}}”": "Közzétéve innen: „{{name}}”",
	"No document is served at / yet.": "Még nincs a / alatt kiszolgált dokumentum.",
	"{{count}} documents mounted_one": "{{count}} csatolt dokumentum",
	"{{count}} documents mounted_other": "{{count}} csatolt dokumentum",
	"Pages": "Oldalak",
	"Document": "Dokumentum",
	"Path": "Útvonal",
	"Serving": "Kiszolgálva",
	"Add a document": "Dokumentum hozzáadása",
	"Add a document to the site": "Dokumentum hozzáadása a webhelyhez",
	"Choose the document to serve at /": "Válaszd ki a / alatt kiszolgált dokumentumot",
	"No site yet": "Még nincs webhely",
	"A site serves the pages of your documents at your own address.": "A webhely a dokumentumaid oldalait szolgálja ki a saját címeden.",
	"Changing a path takes effect when that document is next published.": "Az útvonal módosítása a dokumentum következő közzétételekor lép életbe.",
	"Not published yet": "Még nincs közzétéve",
	"Not published": "Nincs közzétéve",
	"Not part of the site yet": "Még nem része a webhelynek",
	"Not part of the site yet — give it a path.": "Még nem része a webhelynek — adj meg egy útvonalat.",
	"Serving {{path}}": "Kiszolgálva itt: {{path}}",
	"Moves to {{path}} on next publish": "A következő közzétételkor ide kerül: {{path}}",
	"Serving {{published}} — moves to {{configured}} when this document is next published": "Kiszolgálva itt: {{published}} — a következő közzétételkor ide kerül: {{configured}}",
	"Change the root document": "Gyökérdokumentum módosítása",
	"Remove from the site": "Eltávolítás a webhelyről",
	"Remove from the site?": "Eltávolítod a webhelyről?",
	"“{{name}}” stops being served. The document itself is not deleted.": "A(z) „{{name}}” kiszolgálása megszűnik. Maga a dokumentum nem törlődik.",
	"Path for {{name}}": "{{name}} útvonala",
	"This document is already part of the site.": "Ez a dokumentum már része a webhelynek.",
	"“{{name}}” is already mounted here.": "„{{name}}” már ide van csatolva.",
	"“{{segment}}” is reserved.": "A(z) „{{segment}}” foglalt.",
	"Use lowercase letters, digits and dashes only.": "Csak kisbetűk, számjegyek és kötőjelek használhatók.",
	"A path cannot contain “.” or “..”.": "Az útvonal nem tartalmazhat „.” vagy „..” elemet.",
	"A path starts at the site root.": "Az útvonal a webhely gyökerétől indul.",
	"This path is too long.": "Ez az útvonal túl hosszú.",
	"Navigation": "Navigáció",
	"Navigation mode": "Navigáció módja",
	"Automatic": "Automatikus",
	"Custom": "Egyéni",
	"Target": "Cél",
	"Automatic: the site lists the top-level pages of the document served at /. Take it over to reorder, rename or add items, including links into another document and addresses elsewhere.": "Automatikus: a webhely a / alatt kiszolgált dokumentum legfelső szintű oldalait sorolja fel. Vedd át, ha átrendeznéd, átneveznéd vagy bővítenéd — akár egy másik dokumentumba mutató hivatkozással vagy külső címmel.",
	"Custom: this list is what the site serves, in this order. It takes effect at once — no document has to be published again.": "Egyéni: a webhely ezt a listát szolgálja ki, ebben a sorrendben. Azonnal életbe lép — egyetlen dokumentumot sem kell újra közzétenni.",
	"Nothing to show yet — the navigation appears once the root document is published.": "Még nincs mit megjeleníteni — a navigáció a gyökérdokumentum közzététele után jelenik meg.",
	"No items yet — add the first one below.": "Még nincs elem — add hozzá az elsőt alább.",
	"Every item needs a label and a target.": "Minden elemhez kell címke és cél.",
	"A target must be a path or an http(s) address.": "A célnak útvonalnak vagy http(s) címnek kell lennie.",
	"Add item": "Elem hozzáadása",
	"Add a navigation item": "Navigációs elem hozzáadása",
	"Add an item under “{{name}}”": "Elem hozzáadása ide: „{{name}}”",
	"Add sub-item": "Alelem hozzáadása",
	"not published yet": "még nincs közzétéve",
	"Reading the published pages…": "Közzétett oldalak beolvasása…",
	"No document has published any pages yet.": "Még egyetlen dokumentum sem tett közzé oldalt.",
	"The published pages could not be listed. Enter a path below.": "A közzétett oldalakat nem sikerült felsorolni. Adj meg egy útvonalat alább.",
	"Or a path of your own, or an address elsewhere": "Vagy egy saját útvonal, vagy egy külső cím",
	"Path or address": "Útvonal vagy cím",
	"/about or https://example.com": "/rolunk vagy https://example.com",
	"Use a path like /about, or an http(s) address.": "Adj meg egy útvonalat (például /rolunk) vagy egy http(s) címet.",
	"Go back to automatic navigation?": "Visszaállsz az automatikus navigációra?",
	"The navigation you built is discarded and the site lists its top-level pages again.": "Az összeállított navigáció elveszik, és a webhely ismét a legfelső szintű oldalait sorolja fel.",
	"Only the owner or a community leader can change these settings.": "Ezeket a beállításokat csak a tulajdonos vagy egy közösségi vezető módosíthatja.",
	"Site settings saved.": "A webhely beállításai elmentve.",
	"Failed to load the site settings.": "Nem sikerült betölteni a webhely beállításait.",
	"Failed to save the site settings.": "Nem sikerült menteni a webhely beállításait.",
	"Published versions": "Közzétett verziók",
	"Publishing happens in the notes app that holds the document.": "A közzététel a dokumentumot tartalmazó jegyzetalkalmazásban történik.",
	"Nothing published yet": "Még nincs semmi közzétéve",
	"Publish from the notes app.": "Tedd közzé a jegyzetalkalmazásból.",
	"Each document keeps the version being served and the one before it. Rolling back swaps them, and rolling back again puts it right.": "Minden dokumentum megőrzi a kiszolgált verziót és az azt megelőzőt. A visszaállítás felcseréli őket, az ismételt visszaállítás pedig helyreállítja.",
	"Open in the notes app": "Megnyitás a jegyzetalkalmazásban",
	"replaced": "lecserélve",
	"Roll back": "Visszaállítás",
	"Rolled back to the previous version.": "Visszaállítva az előző verzióra.",
	"Failed to download the container.": "Nem sikerült letölteni a csomagot.",
	"Failed to roll back.": "Nem sikerült visszaállítani.",
	"Replace the home page?": "Lecseréled a főoldalt?",
	"“{{name}}” moves to {{path}} and “{{next}}” is served at / instead.": "A(z) „{{name}}” átkerül a {{path}} címre, és helyette a(z) „{{next}}” szolgál a / alatt.",
	"Stop serving the home page?": "Megszünteted a főoldal kiszolgálását?",
	"“{{name}}” stops being served at /, and the site has no home page until another document takes it. The document itself is not deleted.": "A(z) „{{name}}” kiszolgálása a / alatt megszűnik, és a webhelynek nem lesz főoldala, amíg egy másik dokumentum át nem veszi. Maga a dokumentum nem törlődik.",
	"Stop serving at /": "Kiszolgálás megszüntetése a / alatt",
	"Site navigation": "Webhely navigáció",
	"Edit this page": "Oldal szerkesztése",
	"This address is not part of this site.": "Ez a cím nem része ennek a webhelynek.",
	"Go to the start page": "Ugrás a kezdőlapra",
	"Could not load this page. Check your connection.": "Nem sikerült betölteni ezt az oldalt. Ellenőrizd a kapcsolatot.",
	"Move up": "Mozgatás felfelé",
	"Move down": "Mozgatás lefelé",
	"Navigation items": "Navigációs elemek",
	"Share a document": "Dokumentum megosztása",
	"Could not tell which server holds this document.": "Nem sikerült megállapítani, melyik kiszolgálón van ez a dokumentum.",
	"You can only read this document, so you cannot share it to your feed.": "Ezt a dokumentumot csak olvashatod, ezért nem oszthatod meg a hírfolyamodban.",
	"Remove document": "Dokumentum eltávolítása",
	"This document is visible to fewer people than the post.": "Ezt a dokumentumot kevesebben látják, mint a bejegyzést.",
	"Let people who see this post read it": "Aki látja a bejegyzést, olvashassa is",
	"{{name}} in hand": "{{name}} a kézben",
	"Attach": "Csatolás",
	"live document": "élő dokumentum",
	"{{app}} document": "{{app}} dokumentum",
	"Collapse": "Összecsukás",
	"Open document": "Dokumentum megnyitása",
	"{{action}} — still starting up, try again in a moment": "{{action}} — még indul, próbáld újra egy pillanat múlva",
	"Open on its own page": "Megnyitás saját oldalán",
	"Decide whether to identify yourself to {{idTag}} first": "Előbb döntsd el, hogy azonosítod-e magad {{idTag}} felé",
	"This document cannot be opened anonymously.": "Ez a dokumentum nem nyitható meg névtelenül.",
	"Failed to change starred state": "A csillagozás módosítása sikertelen",
	"Failed to change pinned state": "A rögzítés módosítása sikertelen",
	"This file cannot be opened": "Ez a fájl nem nyitható meg",
	"Share to feed": "Megosztás a hírfolyamon",
	"Could not share this document": "A dokumentum megosztása sikertelen",
	"Pin {{name}}": "{{name}} rögzítése",
	"Unpin {{name}}": "{{name}} levétele",
	"Other apps": "További alkalmazások",
	"Pin {{name}} to top bar": "{{name}} rögzítése a felső sávra",
	"{{name}} settings": "{{name}} beállításai",
	"My settings": "Saját beállítások",
	"All communities": "Összes közösség",
	"{{count}} more communities_one": "még {{count}} közösség",
	"{{count}} more communities_other": "még {{count}} közösség",
	"Find a community…": "Közösség keresése…",
	"No community matches.": "Nincs találat.",
	"You are not a member of any community yet.": "Még egyetlen közösségnek sem tagja.",
	"Manage all": "Összes kezelése",
	"Context": "Környezet",
	"Other": "Egyéb",
	"Switch community": "Közösségváltás",
	"Pinned communities": "Kitűzött közösségek",
	"View profile of {{name}}": "{{name}} profiljának megtekintése",
	"Results": "Találatok",
	"Show full path": "Teljes útvonal megjelenítése",
	"code": "kód",
	"Drop files here or click to browse": "Húzd ide a fájlokat, vagy kattints a tallózáshoz",
	"Drop files here": "Húzd ide a fájlokat",
	"Selected": "Kijelölve",
	"Loading": "Betöltés",
	"position {{pos}} of {{total}}": "{{pos}}. pozíció / {{total}}",
	"Picked up {{name}}, {{where}}": "{{name}} felvéve, {{where}}",
	"Moved to {{where}}": "Áthelyezve ide: {{where}}",
	"Dropped {{name}} at {{where}}": "{{name}} lerakva ide: {{where}}",
	"Cancelled, {{name}} returned": "Megszakítva, {{name}} visszakerült",
	"{{name}} moved to position {{pos}} of {{total}}": "{{name}} áthelyezve a(z) {{pos}}. pozícióra / {{total}}",
	"Item": "Elem",
	"Move {{name}}": "{{name}} áthelyezése",
	"Move to top": "Mozgatás a tetejére",
	"Remove {{label}}": "{{label}} eltávolítása",
	"{{name}} inside {{target}}": "{{name}} ebbe: {{target}}",
	"{{name}} before {{target}}": "{{name}} ez elé: {{target}}",
	"{{name}} after {{target}}": "{{name}} ez után: {{target}}",
	"Picked up {{name}}": "{{name}} felvéve",
	"Dropped: {{where}}": "Lerakva: {{where}}",
	"Cancelled, {{name}} not moved": "Megszakítva, {{name}} nem mozdult",
	"Video failed to load": "A videó betöltése sikertelen",
	"Edit tags": "Címkék szerkesztése",
	"View mode": "Nézet",
	"Previous page": "Előző oldal",
	"Next page": "Következő oldal",
	"Zoom out": "Kicsinyítés",
	"Zoom in": "Nagyítás",
	"Discard unsynced work?": "Elveted a nem szinkronizált munkát?",
	"This will discard those unsynced changes along with all other locally stored data, and require you to log in again.": "Ez elveti a nem szinkronizált módosításokat és minden más helyben tárolt adatot, majd újra be kell jelentkezned.",
	"Discard": "Elvetés",
	"Revoke API key?": "Visszavonod az API-kulcsot?",
	"Identity Provider": "Identitásszolgáltató",
	"Section title": "Szakasz címe",
	"Section options": "Szakasz beállításai",
	"Remove entry": "Bejegyzés eltávolítása",
	"Link icon": "Hivatkozás ikonja",
	"Present": "Jelenleg",
	"Connection requested": "Kapcsolódási kérés elküldve",
	"Provider domain": "Szolgáltató domainje",
	"Show tab": "Lap megjelenítése",
	"Tab label": "Lap felirata",
	"…": "…",
	"Push notifications": "Push-értesítések",
	"Email notifications": "E-mail értesítések",
	"Toast notifications": "Felugró értesítések",
	"Delete passkey": "Hozzáférési kulcs törlése",
	"Stop serving": "Kiszolgálás leállítása",
	"Test email recipient": "Teszt e-mail címzettje",
	"Copy invitation link": "Meghívó hivatkozás másolása",
	"{{count}} uses left_one": "Még {{count}} felhasználás",
	"{{count}} uses left_other": "Még {{count}} felhasználás",
	"Tenants": "Bérlők",
	"Tenant": "Bérlő",
	"Add image": "Kép hozzáadása",
	"Take photo": "Fénykép készítése",
	"Add video": "Videó hozzáadása",
	"Filters": "Szűrők",
	"Post": "Bejegyzés",
	"Emoji": "Emoji",
	"Still starting up, try again in a moment": "Még indul, próbáld újra egy pillanat múlva",
	"Conversations": "Beszélgetések",
	"Folder": "Mappa",
	"PDF document": "PDF dokumentum",
	"Video": "Videó",
	"Text file": "Szövegfájl",
	"<0>{{name}}</0> in <1>{{community}}</1>": "<0>{{name}}</0> itt: <1>{{community}}</1>",
	"Hide password": "Jelszó elrejtése",
	"Show password": "Jelszó megjelenítése",
	"Contains characters that look like letters": "Betűnek látszó karaktereket tartalmaz",
	"Week of month": "A hónap hete",
	"Weekday": "A hét napja",
	"Address books": "Címjegyzékek",
	"Attachment {{n}}": "{{n}}. melléklet",
	"Remove {{name}}": "{{name}} eltávolítása",
	"identity tag": "identitáscímke",
	"QR code of your identity": "Az identitásod QR-kódja",
	"Switch camera": "Kameraváltás",
	"Flash": "Vaku",
	"Let readers of this document see {{name}}?": "Láthatják a dokumentum olvasói ezt: {{name}}?",
	"Make {{name}} public? Anyone will be able to see it.": "Nyilvánossá teszed ezt: {{name}}? Bárki láthatja majd.",
	"Not shared": "Nincs megosztva",
	"Move left": "Mozgatás balra",
	"Move right": "Mozgatás jobbra",
	"Crop image": "Kép vágása",
	"Actions for {{name}}": "Műveletek: {{name}}",
	"Unpin from strip": "Levétel a sávról",
	"Pin to strip": "Kitűzés a sávra",
	"Remove tag {{tag}}": "{{tag}} címke eltávolítása",
	"Add tag": "Címke hozzáadása",
	"Unverified": "Nem ellenőrzött",
	"App trust:": "Alkalmazás-megbízhatóság:",
	"This app needs trusted mode": "Ez az alkalmazás csak megbízható módban futhat",
	"It can only run when its trust level is set to trusted.": "Csak akkor futtatható, ha a megbízhatósági szintje „megbízható”.",
	"via <hat/>": "a(z) <hat/> nevében",
	"<name/> via <hat/>": "<name/> a(z) <hat/> nevében",
	"Room": "Szoba",
	"Rooms": "Szobák",
	"Anyone can enter": "Bárki beléphet",
	"visible to everyone": "mindenki számára látható",
	"visible to signed-in people": "bejelentkezett felhasználók számára látható",
	"visible to followers": "követők számára látható",
	"hidden from people who cannot enter": "rejtett azok elől, akik nem léphetnek be",
	"invitation only": "csak meghívással",
	"Failed to save room": "A szoba mentése sikertelen",
	"Room saved": "Szoba mentve",
	"Room created": "Szoba létrehozva",
	"Can't be changed later": "Később nem módosítható",
	"Lowercase letters, digits and dashes": "Kisbetűk, számjegyek és kötőjelek",
	"Invalid room name": "Érvénytelen szobanév",
	"Who can enter": "Ki léphet be",
	"Followers and above": "Követők és afölött",
	"Supporters and above": "Támogatók és afölött",
	"Contributors and above": "Közreműködők és afölött",
	"Moderators and above": "Moderátorok és afölött",
	"Leaders only": "Csak vezetők",
	"{{count}} people are followers or above_one": "{{count}} személy követő vagy afölött",
	"{{count}} people are followers or above_other": "{{count}} személy követő vagy afölött",
	"{{count}} people are supporters or above_one": "{{count}} személy támogató vagy afölött",
	"{{count}} people are supporters or above_other": "{{count}} személy támogató vagy afölött",
	"{{count}} people are contributors or above_one": "{{count}} személy közreműködő vagy afölött",
	"{{count}} people are contributors or above_other": "{{count}} személy közreműködő vagy afölött",
	"{{count}} people are moderators or above_one": "{{count}} személy moderátor vagy afölött",
	"{{count}} people are moderators or above_other": "{{count}} személy moderátor vagy afölött",
	"{{count}} people are leaders_one": "{{count}} személy vezető",
	"{{count}} people are leaders_other": "{{count}} személy vezető",
	"Their role with you": "Az ő szerepe nálad",
	"Invitation only": "Csak meghívással",
	"People must be invited or have their request approved.": "Csak meghívottak vagy jóváhagyott kérelmezők léphetnek be.",
	"Who can see this room exists": "Ki láthatja, hogy a szoba létezik",
	"Everyone": "Mindenki",
	"Signed-in people": "Bejelentkezett felhasználók",
	"Only people who can enter": "Csak akik beléphetnek",
	"Create room": "Szoba létrehozása",
	"You need moderator permissions to manage rooms.": "A szobák kezeléséhez moderátori jogosultság szükséges.",
	"New room": "Új szoba",
	"No rooms yet": "Még nincsenek szobák",
	"Rooms group posts and files for a subset of people.": "A szobák bejegyzéseket és fájlokat gyűjtenek egy szűkebb kör számára.",
	"{{count}} members": "{{count}} tag",
	"Room not found": "A szoba nem található",
	"Failed to load room members": "Nem sikerült betölteni a szoba tagjait",
	"Invite to room": "Meghívás a szobába",
	"Search members who can enter this room": "Keress a szobába beléphető tagok között",
	"Remove from room": "Eltávolítás a szobából",
	"{{name}} will no longer be able to enter this room.": "{{name}} többé nem léphet be ebbe a szobába.",
	"Decline": "Elutasítás",
	"Failed to accept request": "Nem sikerült elfogadni a kérést",
	"Failed to decline request": "Nem sikerült elutasítani a kérést",
	"Invite": "Meghívás",
	"No members yet": "Még nincsenek tagok",
	"Delete room": "Szoba törlése",
	"Content stays but becomes readable only by {{tenant}}.": "A tartalom megmarad, de csak {{tenant}} olvashatja.",
	"Failed to delete room": "Nem sikerült törölni a szobát",
	"Danger zone": "Veszélyzóna",
	"wants to join ~{{room}}": "csatlakozna ide: ~{{room}}",
	"invited you to ~{{room}} at {{tenant}}": "meghívott ide: ~{{room}} ({{tenant}})",
	"Requested": "Kérelmezve",
	"Ask to join": "Csatlakozás kérése",
	"Create a room": "Szoba létrehozása",
	"Leave room": "Kilépés a szobából",
	"Leave {{room}}? You will need an invitation or approval to come back.": "Kilépsz innen: {{room}}? A visszatéréshez meghívás vagy jóváhagyás kell.",
	"Failed to send request": "Nem sikerült elküldeni a kérést",
	"Failed to leave room": "Nem sikerült kilépni a szobából",
	"Members only": "Csak tagoknak",
	"Show only ~{{room}}": "Csak ~{{room}}",
	"Mute ~{{room}}": "~{{room}} némítása",
	"Unmute ~{{room}}": "~{{room}} némításának feloldása",
	"You muted this room. Its posts don't show in your unfiltered feed.": "Ezt a szobát elnémítottad. A bejegyzései nem jelennek meg a szűretlen hírfolyamodban.",
	"Muted rooms": "Elnémított szobák",
	"Failed to unmute room": "Nem sikerült feloldani a szoba némítását",
	"~ Open floor": "~ Nyitott tér",
	"Invited members only": "Csak meghívott tagok",
	"Community map": "Közösségi térkép",
	"Sync": "Szinkronizálás",
	"Syncing…": "Szinkronizálás…",
	"Map": "Térkép",
	"List": "Lista",
	"Last synced {{time}}": "Utoljára szinkronizálva: {{time}}",
	"Never synced": "Még nem volt szinkronizálva",
	"Could not load the community map": "Nem sikerült betölteni a közösségi térképet",
	"The map shows the communities you are a member of, and the communities they are partners with. Sync to fetch the latest partner lists.": "A térkép azokat a közösségeket mutatja, amelyeknek tagja vagy, és azok partnerközösségeit. Szinkronizálj a legfrissebb partnerlisták lekéréséhez.",
	"{{name}}, member community": "{{name}}, tagközösség",
	"{{name}}, partner of {{parents}}": "{{name}}, partnere: {{parents}}",
	"+{{count}} more": "+{{count}} további",
	"Reset view": "Nézet visszaállítása",
	"<0>{{a}}</0> and <1>{{b}}</1> are now partners": "<0>{{a}}</0> és <1>{{b}}</1> mostantól partnerek",
	"Failed to create document": "Nem sikerült létrehozni a dokumentumot",
	"Failed to create folder": "Nem sikerült létrehozni a mappát",
	"Browse rooms…": "Szobák böngészése…",
	"All {{context}} members": "{{context}} összes tagja",
	"Only you": "Csak te",
	"Invited members": "Meghívott tagok",
	"{{count}} people_one": "{{count}} fő",
	"{{count}} people_other": "{{count}} fő",
	"Everyone who can see {{context}}": "Mindenki, aki látja ezt: {{context}}",
	"No files in ~{{room}} yet.": "Még nincsenek fájlok itt: ~{{room}}.",
	"Files you add here are visible to {{audience}}.": "Az ide feltöltött fájlokat láthatja: {{audience}}.",
	"Move to {{place}}?": "Áthelyezés ide: {{place}}?",
	"Restore to {{place}}?": "Visszaállítás ide: {{place}}?",
	"Place in {{place}}?": "Elhelyezés itt: {{place}}?",
	"They will be visible to {{audience}}.": "Láthatóvá válnak a következők számára: {{audience}}.",
	"Only moderators can move other members' files out of ~{{room}}": "Csak moderátorok helyezhetik át más tagok fájljait innen: ~{{room}}",
	"This file is in several folders — pick it up from your own Files": "Ez a fájl több mappában is szerepel — vedd fel a saját Fájljaid közül",
	"Could not load rooms": "A szobák betöltése sikertelen",
	"Open files": "Fájlok megnyitása",
	"~{{room}} still has {{count}} files. Move or delete them first._one": "~{{room}} még {{count}} fájlt tartalmaz. Előbb helyezd át vagy töröld.",
	"~{{room}} still has {{count}} files. Move or delete them first._other": "~{{room}} még {{count}} fájlt tartalmaz. Előbb helyezd át vagy töröld őket.",
	"Sharing gives access even to people outside ~{{room}}.": "A megosztás a ~{{room}} szobán kívülieknek is hozzáférést ad.",
	"Take the tour": "Bemutató megtekintése",
	"Welcome to Cloudillo": "Üdv a Cloudillóban",
	"A quick look around: where things are and what they do. It takes a minute.": "Egy gyors körbenézés: mi hol van és mire való. Csak egy perc.",
	"Your apps": "Az alkalmazásaid",
	"Feed, files, messages and the rest of your apps are always within reach here.": "A hírfolyam, a fájlok, az üzenetek és a többi alkalmazás itt mindig kéznél van.",
	"Share a post": "Bejegyzés megosztása",
	"Write a post, add photos or documents, and choose who can see it. Posts from people and communities you follow show up below.": "Írj bejegyzést, csatolj fotókat vagy dokumentumokat, és válaszd ki, ki láthatja. Az általad követett emberek és közösségek bejegyzései alatta jelennek meg.",
	"Create and upload": "Létrehozás és feltöltés",
	"Start a new document, spreadsheet, presentation or whiteboard, or upload files. Everything is stored on your own node.": "Hozz létre új dokumentumot, táblázatot, prezentációt vagy táblát, vagy tölts fel fájlokat. Minden a saját csomópontodon tárolódik.",
	"Your space and communities": "A saját tered és a közösségek",
	"Switch between your personal space and the communities you belong to. Each one has its own feed, files and apps.": "Válts a saját tered és a közösségeid között. Mindegyiknek saját hírfolyama, fájljai és alkalmazásai vannak.",
	"Find people, communities, posts and files.": "Keress embereket, közösségeket, bejegyzéseket és fájlokat.",
	"Private conversations and group chats.": "Privát beszélgetések és csoportos csevegések.",
	"Invitations, connection requests and other things that need your attention.": "Meghívások, kapcsolatkérések és minden, ami a figyelmedre vár.",
	"Your account": "A fiókod",
	"Your profile, your card and settings live here. You can also take this tour again from this menu.": "Itt éred el a profilodat, a névjegyedet és a beállításokat. Ebből a menüből a bemutatót is újraindíthatod.",
	"You're all set": "Minden kész",
	"Enjoy Cloudillo!": "Jó szórakozást a Cloudillóval!",
	"Take a quick tour?": "Megnézed a rövid bemutatót?",
	"See where things are in Cloudillo. It takes about a minute.": "Nézd meg, mi hol található a Cloudillóban. Körülbelül egy perc.",
	"Not now": "Most nem",
	"Start": "Indítás",
	"Loading {{title}}": "{{title}} betöltése",
	"You're offline. This embed loads when you reconnect.": "Nincs internetkapcsolat. A beágyazás az újracsatlakozáskor betöltődik.",
	"You don't have access to this document": "Nincs hozzáférésed ehhez a dokumentumhoz",
	"This view no longer exists": "Ez a nézet már nem létezik",
	"This embed comes from a source you have not trusted yet": "Ez a beágyazás egy még nem megbízhatónak jelölt forrásból származik",
	"This embed couldn't be loaded": "A beágyazást nem sikerült betölteni",
	"Request access": "Hozzáférés kérése",
	"Load anyway": "Betöltés mégis",
	"Open source": "Forrás megnyitása",
	"Offline": "Offline",
	"View missing": "A nézet hiányzik",
	"Not trusted": "Nem megbízható",
	"Use current view": "Jelenlegi nézet használata",
	"Interact": "Interakció",
	"Embed size": "Beágyazás mérete",
	"Embed options": "Beágyazás beállításai",
	"Embed": "Beágyazás",
	"People who can see this document will be able to open all of \"{{name}}\", not only the part you embed.": "Akik látják ezt a dokumentumot, a teljes „{{name}}” dokumentumot megnyithatják, nem csak a beágyazott részt.",
	"Change view": "Nézet módosítása",
	"Unlink": "Leválasztás",
	"Allow editing": "Szerkesztés engedélyezése",
	"Actual size": "Tényleges méret",
	"Scale": "Méretarány",
	"Max height": "Max. magasság",
	"Text size": "Szövegméret",
	"Width": "Szélesség",
	"Align left": "Balra igazítás",
	"Align center": "Középre igazítás",
	"Align right": "Jobbra igazítás",
	"Only documents from this context can be embedded.": "Csak ebből a kontextusból származó dokumentumok ágyazhatók be.",
	"The linked document could not be embedded.": "A hivatkozott dokumentumot nem sikerült beágyazni.",
	"Embed link copied": "Beágyazási link másolva",
	"Failed to copy embed link": "A beágyazási link másolása nem sikerült",
	"Allow editing “{{name}}” from “{{host}}”?": "Engedélyezed a(z) „{{name}}” szerkesztését a(z) „{{host}}” dokumentumból?",
	"Copy embed link": "Beágyazási link másolása",
	"Shrink to fit": "Kicsinyítés a szélességhez",
	"Embedded document": "Beágyazott dokumentum",
	"This embed is nested too deeply or embeds itself": "Ez a beágyazás túl mélyen van egymásba ágyazva, vagy önmagát ágyazza be",
	"This kind of document can't be embedded.": "Ez a dokumentumtípus nem ágyazható be.",
	"You can't add embeds to this document.": "Ebbe a dokumentumba nem adhatsz hozzá beágyazást.",
	"Whole document": "Teljes dokumentum",
	"Choose a view…": "Nézet kiválasztása…",
	"Embed all of \"{{name}}\", or only a part of it?": "A teljes „{{name}}” dokumentumot ágyazod be, vagy csak egy részét?",
	"Use this view": "Ez a nézet",
	"Select the part you want to embed": "Jelöld ki a beágyazandó részt",
	"Preparing embeds {{n}} of {{m}}…": "Beágyazások előkészítése: {{n}} / {{m}}…",
	"Offline · changes saved on this device": "Offline · a változások ezen az eszközön mentve",
	"Reconnecting…": "Újracsatlakozás…",
	"Synced": "Szinkronizálva",
	"Partner communities ({{count}})_one": "Partnerközösségek ({{count}})",
	"Partner communities ({{count}})_other": "Partnerközösségek ({{count}})",
	"Color": "Szín",
	"Neutral": "Semleges",
	"Blue": "Kék",
	"Violet": "Ibolya",
	"Magenta": "Bíbor",
	"Rose": "Rózsa",
	"Amber": "Borostyán",
	"Sand": "Homok",
	"Green": "Zöld",
	"Followers+": "Követők+",
	"Supporters+": "Támogatók+",
	"Contributors+": "Közreműködők+",
	"Mods+": "Moderátorok+",
	"All members": "Minden tag",
	"Only the owner": "Csak a tulajdonos",
	"Shared with you": "Megosztva veled",
	"via /{{folder}}": "/{{folder}} mappán keresztül",
	"inherited": "örökölt",
	"Audience": "Közönség",
	"No one else has access": "Senki más nem fér hozzá",
	"No share links": "Nincs megosztási link",
	"Manage sharing…": "Megosztás kezelése…",
	"Access: {{audience}}, {{people}}, {{links}}": "Hozzáférés: {{audience}}, {{people}}, {{links}}",
	"Private": "Privát",
	"Could not load who has access. Please try again.": "Nem sikerült betölteni, ki fér hozzá. Kérjük, próbáld újra.",
	"Only people who can manage sharing can change it": "Csak a megosztást kezelni tudók módosíthatják",
	"Search names in {{place}}": "Nevek keresése itt: {{place}}",
	"Clear selection": "Kijelölés törlése",
	"Room directory →": "Szobák jegyzéke →",
	"Search {{place}}": "Keresés itt: {{place}}",
	"Searching all of {{place}}, including subfolders": "Keresés a teljes {{place}} területén, almappákkal együtt",
	"Back to {{place}}": "Vissza ide: {{place}}",
	"Only {{place}}": "Csak: {{place}}",
	"Only top level of {{place}}": "Csak {{place}} legfelső szintje",
	"All of {{place}}": "Teljes {{place}}",
	"No files match these filters": "Egy fájl sem felel meg ezeknek a szűrőknek",
	"Folders are hidden while filtering by Images": "A mappák rejtve vannak, amíg képekre szűrsz",
	"Sorted by last opened while Recent is on": "A Legutóbbiak bekapcsolásakor utolsó megnyitás szerint rendezve",
	"Any type": "Bármilyen típus",
	"Folders": "Mappák",
	"Shared with people": "Személyekkel megosztva",
	"Shared by link": "Linkkel megosztva",
	"Modified": "Módosítva",
	"Last 7 days": "Az elmúlt 7 nap",
	"Last 30 days": "Az elmúlt 30 nap",
	"Last year": "Az elmúlt év",
	"My permission": "Saját jogosultság",
	"Remove {{filter}} filter": "{{filter}} szűrő eltávolítása",
	"More filters": "További szűrők",
	"Sort by {{field}}": "Rendezés: {{field}}",
	"Ascending": "Növekvő",
	"Descending": "Csökkenő",
	"Layout": "Elrendezés",
	"Grid": "Rács",
	"Search tags": "Címkék keresése",
	"No tags found": "Nincs találat címkére",
	"Some files may be hidden by ‘My permission’.": "Egyes fájlokat a ‘Saját jogosultság’ szűrő elrejthet.",
	"Load more": "Több betöltése",
	"Active filters": "Aktív szűrők",
	"Search file names for “{{q}}” in {{place}}": "Fájlnevek keresése: „{{q}}” itt: {{place}}",
	"Invited · {{count}}_one": "Meghívott · {{count}}",
	"Invited · {{count}}_other": "Meghívott · {{count}}",
	"{{count}} links_one": "{{count}} link",
	"{{count}} links_other": "{{count}} link",
	"{{count}} filters_one": "{{count}} szűrő",
	"{{count}} filters_other": "{{count}} szűrő",
	"Clear {{count}} filters_one": "{{count}} szűrő törlése",
	"Clear {{count}} filters_other": "{{count}} szűrő törlése",
	"{{count}} selected_one": "{{count}} kijelölve",
	"{{count}} selected_other": "{{count}} kijelölve",
	"Teal": "Kékeszöld",
	"Sign in to join": "Jelentkezz be a csatlakozáshoz",
	"All rooms": "Minden szoba",
	"Only room members can see the member list.": "A taglistát csak a szoba tagjai láthatják.",
	"Room home": "Szoba kezdőlapja",
	"Rooms ({{count}}) →_one": "Szobák ({{count}}) →",
	"Rooms ({{count}}) →_other": "Szobák ({{count}}) →",
	"Who can create rooms": "Ki hozhat létre szobát",
	"Any member": "Bármelyik tag",
	"Only leaders can change who can create rooms.": "Csak a vezetők módosíthatják, ki hozhat létre szobát.",
	"Manage rooms →": "Szobák kezelése →",
	"Create or manage rooms": "Szobák létrehozása vagy kezelése",
	"Your rooms": "Szobáid",
	"Viewing": "Megtekintve",
	"Members · {{count}}_one": "Tagok · {{count}}",
	"Members · {{count}}_other": "Tagok · {{count}}"
}
